function FormatReader(){this.mimetype=["image/png","image/jpeg"],"undefined"!=typeof PDFJS&&(this.mimetype.push("application/pdf"),PDFJS.disableWorker=!1),"undefined"!=typeof Tiff&&(this.mimetype.push("image/tif"),this.mimetype.push("image/tiff"));try{var e=$window.AudioContext||$window.webkitAudioContext||$window.mozAudioContext||$window.msAudioContext;"undefined"!=typeof e&&(this.mimetype.push("audio/x-wav"),this.mimetype.push("audio/wav"),this.mimetype.push("audio/x-ogg"),this.mimetype.push("audio/ogg"),this.mimetype.push("audio/x-mpeg"),this.mimetype.push("audio/mpeg"))}catch(t){}}FormatReader.prototype={pdfReader:function(e,t,i,o,n,a){function r(e,o,n){void 0==o&&(o=d.currentPage),void 0==n&&(n=e.page);var a=document.createElement("canvas"),r=a.getContext("2d");if(null!=n){e.rendering=!0,e.oldwidth=e.width,e.oldheight=e.height,0==Math.abs(e.options.zoom.value)&&(e.options.zoom.value=1);var s=n.getViewport(e.options.zoom.value,0);return r.canvas.width=s.width,r.canvas.height=s.height,n.render({canvasContext:r,viewport:s,intent:"display"}).then(function(){if(e.width=s.width,e.height=s.height,t.controls.filmStrip){var n=r.getImageData(0,0,s.width,s.height);n.pageNum=o,e.data.push(n),e.data.length==t.controls.totalPage&&(e.data.sort(function(e,t){return e.pageNum-t.pageNum}),e.rendered=!0,i(),e.rendering=!1)}else d.data=r.getImageData(0,0,s.width,s.height),d.rendered=!0,i(),e.rendering=!1})}}t.controls.toolbar&&(t.controls.image=!0,t.controls.sound=!1),this.reader=new FileReader;var d=this;return d.context=a,d.$q=o,d._pdfDoc=null,d.viewport=null,d.img=new Image,d.rendered=!1,d.width=-1,d.height=-1,d.oldwidth=-1,d.oldheight=-1,d.data=null,d.page=null,d.options=t,d.currentPage=-1,d.rendering=!1,d.isZoom=!1,d.data=[],d.triggerRefresh=!1,this.refresh=function(){if(null!=d._pdfDoc&&!parent.rendering)if(d.rendered=!1,t.controls.filmStrip){var e=1,i=[];d.data=[];for(var e=1;e<=t.controls.totalPage;e++)i.push(d._pdfDoc.getPage(e));d.$q.all(i).then(function(e){for(var t=0;t<e.length;t++)r(d,e[t].pageIndex,e[t])})}else d.currentPage!=d.options.controls.numPage?d._pdfDoc.getPage(d.options.controls.numPage).then(function(e){r(d,d.options.controls.numPage,e)}):r(d,d.options.controls.numPage,page)},this.reader.onload=function(){var e=new Uint8Array(d.reader.result);PDFJS.getDocument({data:e}).then(function(e){d._pdfDoc=e,t.controls.totalPage=e.numPages,t.controls.numPage=1,d._pdfDoc.getMetadata().then(function(e){t.info=e.info,t.info.metadata=e.metadata}),d.refresh()})},this.reader.readAsArrayBuffer(e),this},tiffReader:function(e,t,i){t.controls.toolbar&&(t.controls.image=!0,t.controls.sound=!1),this.reader=new FileReader;var o=this;return o.rendered=!1,o.tiff=null,o.img=null,o.data=null,o.width=-1,o.height=-1,o.options=t,o.images=[],o.currentPage=-1,o.isZoom=!0,this.refresh=function(){if(void 0!=o.reader.result)if(null==o.tiff&&(o.tiff=new Tiff({buffer:o.reader.result}),o.options.controls.totalPage=o.tiff.countDirectory(),o.options.controls.numPage=1,o.options.info={width:o.tiff.width(),height:o.tiff.height(),compression:o.tiff.getField(Tiff.Tag.COMPRESSION),document:o.tiff.getField(Tiff.Tag.DOCUMENTNAME),description:o.tiff.getField(Tiff.Tag.IMAGEDESCRIPTION),orientation:o.tiff.getField(Tiff.Tag.ORIENTATION),xresolution:o.tiff.getField(Tiff.Tag.XRESOLUTION),yresolution:o.tiff.getField(Tiff.Tag.YRESOLUTION)}),o.options.controls.numPage>o.options.controls.totalPage&&(o.options.controls.numPage=o.options.controls.totalPage),o.options.controls.filmStrip){o.images=[];for(var e=0;e<o.tiff.countDirectory();e++)o.tiff.setDirectory(e),0==e&&(o.width=o.tiff.width(),o.height=o.tiff.height()),o.images[e]=new Image,o.images[e].onload=function(){1==o.images.length&&(o.img=o.images[0]),i(),o.rendered=!0},o.images[e].src=o.tiff.toDataURL(),o.images[e].pageNum=e}else o.currentPage!=o.options.controls.numPage&&(o.tiff.setDirectory(o.options.controls.numPage-1),o.width=o.tiff.width(),o.height=o.tiff.height(),o.img=new Image,o.img.onload=function(){i(),o.rendered=!0},o.img.src=o.tiff.toDataURL(),o.currentPage=o.options.controls.numPage)},this.reader.onload=function(){null!=o.tiff&&(o.tiff.close(),o.tiff=null),Tiff.initialize({TOTAL_MEMORY:83886080}),o.refresh()},this.reader.readAsArrayBuffer(e),this},imageReader:function(e,t,i){t.controls.toolbar&&(t.controls.image=!0,t.controls.sound=!1),this.reader=new FileReader;var o=this;return o.img=new Image,o.img.onload=function(){o.width=o.img.width,o.height=o.img.height,i(),o.rendered=!0},o.data=null,o.width=-1,o.height=-1,t.info={},o.isZoom=!0,o.rendered=!1,this.reader.onload=function(){o.img.src=o.reader.result},"string"==typeof e?o.img.src=e:this.reader.readAsDataURL(e),t.controls.totalPage=1,t.controls.numPage=1,this.refresh=function(){},this},mpegReader:function(e,t,i){},wavReader:function(e,t,i){t.controls.toolbar&&(t.controls.image=!1,t.controls.sound=!0),this.reader=new FileReader;var o=this,n=t.ctx;this.width=n.canvas.width,this.height=n.canvas.height;try{$window.AudioContext=$window.AudioContext||$window.webkitAudioContext||$window.mozAudioContext||$window.msAudioContext,$window.requestAnimationFrame=$window.requestAnimationFrame||$window.webkitRequestAnimationFrame||$window.mozRequestAnimationFrame||$window.msRequestAnimationFrame,$window.cancelAnimationFrame=$window.cancelAnimationFrame||$window.webkitCancelAnimationFrame||$window.mozCancelAnimationFrame||$window.msCancelAnimationFrame;var a=new AudioContext;this.reader.onload=function(){a.decodeAudioData(o.reader.result,function(e){var i=n.createLinearGradient(0,0,0,o.height);i.addColorStop(1,"#000000"),i.addColorStop(.75,"#ff0000"),i.addColorStop(.25,"#ffff00"),i.addColorStop(0,"#ffffff");var r=a.createScriptProcessor(2048,1,1),d=a.createBufferSource();t.adsrc=d,d.buffer=e;var s=a.createAnalyser();s.smoothingTimeConstant=.3,s.fftSize=512,d.connect(s),s.connect(r),r.onaudioprocess=function(){var e=new Uint8Array(s.frequencyBinCount);s.getByteFrequencyData(e),n.clearRect(0,0,n.canvas.width,n.canvas.height),n.fillStyle=i;for(var t=0;t<e.length;t++){var a=e[t];n.fillRect(5*t,o.height-a,3,o.height)}},r.connect(a.destination),d.connect(a.destination)})},this.reader.readAsArrayBuffer(e)}catch(r){}},CreateReader:function(e,t){var i=null;switch(""==e&&(e=this.GuessMimeType(t)),e.toLowerCase()){case"image/tif":case"image/tiff":i={create:this.tiffReader};break;case"application/pdf":i={create:this.pdfReader};break;case"image/png":case"image/jpeg":i={create:this.imageReader};break;case"audio/x-wav":case"audio/wav":case"audio/x-ogg":case"audio/ogg":i={create:this.wavReader};break;case"audio/x-mpeg":case"audio/mpeg":i={create:this.mpegReader}}return i},IsSupported:function(e){return-1!=this.mimetype.indexOf(e)},GuessMimeType:function(e){var t="";if(""==e.type){var i=e.name;t="image/"+i.substring(i.indexOf(".")+1)}return t.toLowerCase()}};
angular.module("CanvasViewer",[]).directive("canvasViewer",["$window","$http","$timeout","$q",function(o,t,e,n){var i=new FormatReader;return{scope:{imageSource:"=src",overlays:"=overlays",title:"@title",options:"=options"},restrict:"E",template:'<div class="viewer-container"><canvas class="viewer" ng-mouseleave="canMove=false"ng-mousedown="mousedown($event)"ng-mouseup="mouseup($event)"ng-init="canMove=false"ng-mousemove="mousedrag($event,canMove)"></canvas><div class="title" ng-if="title!=null">{{title}}</div><div class="command" ng-if="options.controls.image"><div class="btn btn-info" ng-click="options.controls.numPage=options.controls.numPage-1" ng-hide="options.controls.totalPage==1"><i class="fa fa-minus"></i></div><div class="btn btn-info" ng-hide="options.controls.totalPage==1">{{options.controls.numPage}}/{{options.controls.totalPage}}</div><div class="btn btn-info" ng-click="options.controls.numPage=options.controls.numPage+1" ng-hide="options.controls.totalPage==1"><i class="fa fa-plus"></i></div><div class="btn btn-info" ng-click="resizeTo(\'page\')"><i class="fa fa-file-o"></i></div><div class="btn btn-info" ng-click="rotate(-1)" ng-hide="options.controls.disableRotate"><i class="fa fa-rotate-left"></i></div><div class="btn btn-info" ng-click="rotate(1)" ng-hide="options.controls.disableRotate"><i class="fa fa-rotate-right"></i></div><div class="btn btn-info" ng-click="zoom(-1)" ng-hide="options.controls.disableZoom"><i class="fa fa-search-minus"></i></div><div class="btn btn-info" ng-click="zoom(1)" ng-hide="options.controls.disableZoom"><i class="fa fa-search-plus"></i></div></div><div class="command" ng-if="options.controls.sound"><div class="btn btn-info" ng-click="stop()"><i class="fa fa-stop"></i></div><div class="btn btn-info" ng-click="play()"><i class="fa fa-play"></i></div></div></div>',link:function(t,a,s,l){function r(){null!=z&&(z.rendered?c():t.resizeTo(t.options.controls.fit))}function c(){if(null!=z&&z.rendered){var o=t.options,e=d.canvas,n=z.width*o.zoom.value/2,i=z.height*o.zoom.value/2;if(d.clearRect(0,0,e.width,e.height),d.save(),d.translate(y.x+n,y.y+i),d.rotate(o.rotate.value*Math.PI/180),d.translate(-n,-i),z.isZoom&&d.scale(o.zoom.value,o.zoom.value),o.controls.filmStrip&&1!=o.controls.totalPage){if(null!=z.images&&angular.forEach(z.images,function(o){d.drawImage(o,0,0,o.width,o.height),d.beginPath(),d.rect(0,0,o.width,o.height),d.lineWidth=.2,d.strokeStyle="#000000",d.stroke(),d.translate(0,o.height+15)}),null!=z.data){var a=0;angular.forEach(z.data,function(o){d.putImageData(o,y.x,y.y+a),d.beginPath(),d.rect(0,0,z.width,z.height),d.lineWidth=.2,d.strokeStyle="#000000",d.stroke(),a+=z.height+15,d.translate(0,a)})}}else null!=z.img&&(d.drawImage(z.img,0,0,z.width,z.height),d.beginPath(),d.rect(0,0,z.width,z.height),d.lineWidth=.2,d.strokeStyle="#000000",d.stroke()),null!=z.data&&(d.putImageData(z.data,y.x,y.y),d.beginPath(),d.rect(0,0,z.width,z.height),d.lineWidth=.2,d.strokeStyle="#000000",d.stroke());d.restore(),w.length>0&&angular.forEach(w,function(t){d.save(),d.translate(y.x+n,y.y+i),d.rotate(o.rotate.value*Math.PI/180),d.translate(-n,-i),d.scale(o.zoom.value,o.zoom.value),d.beginPath(),d.rect(t.x,t.y,t.w,t.h),d.fillStyle=t.color,d.globalAlpha=.4,d.fill(),d.lineWidth=1,d.strokeStyle=t.color,d.stroke(),d.restore()})}}function u(){t.$applyAsync(function(){var o=p.parentNode;d.canvas.width=o.clientWidth,d.canvas.height=o.clientHeight,c()})}function h(){return m.width!=p.parentNode.clientWidth&&(m.width=p.parentNode.clientWidth),m.height!=p.parentNode.clientHeight&&(m.height=p.parentNode.clientHeight),m}var p=a.find("canvas")[0],d=p.getContext("2d"),v=angular.element(a.find("div")[0])[0];directiveParentNode=v.parentNode.parentNode;var g=p.parentNode;d.canvas.width=g.clientWidth,d.canvas.height=g.clientHeight;var m={height:g.clientHeight,width:g.clientWidth},f={x:0,y:0},y={x:0,y:0},b={x:0,y:0},w=[],z=null;t.options=angular.merge({},{ctx:null,adsrc:null,zoom:{value:1,step:.1,min:.05,max:6},rotate:{value:0,step:90},controls:{toolbar:!0,image:!0,sound:!1,fit:"page",disableZoom:!1,disableMove:!1,disableRotate:!1,numPage:1,totalPage:1,filmStrip:!1},info:{}},t.options),t.options.ctx=d,t.$watch("imageSource",function(o){if(void 0!==o&&null!==o)if(t.options.zoom.value=1,t.options.rotate.value=0,f={x:0,y:0},y={x:0,y:0},"object"==typeof o)if(i.IsSupported(o.type)){var a=i.CreateReader(o.type,o);z=a.create(o,t.options,r,n,e,d)}else console.log(o.type," not supported !");else"string"==typeof o&&(z=i.CreateReader("image/jpeg").create(o,t.options,r,n,e))}),t.$watch("overlays",function(o,t){null!==o&&null!==t&&(w=[],angular.forEach(o,function(o){w.push(o)}),c())},!0),t.$watch("options.zoom.value",function(){t.options.controls.disableZoom||c()}),t.$watch("options.rotate.value",function(){t.options.controls.disableRotate||c()}),t.$watch("options.controls.fit",function(o){t.resizeTo(o)}),t.$watch("options.controls.filmStrip",function(o){o?(t.options.controls.disableMove=!0,t.options.controls.disableRotate=!0):(t.options.controls.disableMove=!1,t.options.controls.disableRotate=!1),null!=z.refresh&&z.refresh()}),t.$watch("options.controls.numPage",function(o){t.options.controls.numPage<1&&(t.options.controls.numPage=1),t.options.controls.numPage>t.options.controls.totalPage&&(t.options.controls.numPage=t.options.controls.totalPage),null!=z&&(t.options.controls.filmStrip?(y.y=(t.options.controls.numPage-1)*-(z.height+15),c()):null!=z.refresh&&z.refresh())}),angular.element(p).bind("DOMMouseScroll mousewheel onmousewheel",function(e){var n=o.event||e,i=Math.max(-1,Math.min(1,n.wheelDelta||-n.detail));t.options.controls.filmStrip?(y.y+=50*i,y.y>15&&(y.y=15),z.images?y.y-z.height*t.options.zoom.value<-(z.height+15)*z.images.length*t.options.zoom.value&&(y.y=-(z.height+15)*z.images.length+z.height):y.y-z.height*t.options.zoom.value<-z.height*t.options.zoom.value&&(y.y=-z.height*t.options.zoom.value),t.$applyAsync(function(){c()})):i>0?t.zoom(1):t.zoom(-1),n.returnValue=!1,n.preventDefault&&n.preventDefault()}),angular.element(p).bind("mousedown",function(o){t.options.controls.disableMove||(t.canMove=!0,f.x=o.offsetX,f.y=o.offsetY)}),angular.element(p).bind("mouseup",function(o){t.options.controls.disableMove||(t.canMove=!1)}),angular.element(p).bind("mousemove",function(o){if(b.x=o.offsetX,b.y=o.offsetY,!t.options.controls.disableMove&&null!==z&&t.canMove){var e=o.offsetX,n=o.offsetY,i=e-f.x,a=n-f.y;y.x+=i,y.y+=a,c(),f.x=e,f.y=n}}),t.zoom=function(o){t.$applyAsync(function(){var e,n,i=0,a=0;z.isZoom?(e=z.width*t.options.zoom.value,n=z.height*t.options.zoom.value):(e=z.oldwidth,n=z.height),t.options.zoom.value+=t.options.zoom.step*o,t.options.zoom.value=Math.round(100*t.options.zoom.value)/100,t.options.zoom.value>=t.options.zoom.max&&(t.options.zoom.value=t.options.zoom.max),t.options.zoom.value<=t.options.zoom.min&&(t.options.zoom.value=t.options.zoom.min),null!=z.refresh&&z.refresh(),z.isZoom?(i=z.width*t.options.zoom.value,a=z.height*t.options.zoom.value):(i=z.width,a=z.height),y.x=y.x-(i-e)/2,y.y=y.y-(a-n)/2})},t.rotate=function(o){t.$applyAsync(function(){t.options.rotate.value+=t.options.rotate.step*o,(t.options.rotate.value<=-360||t.options.rotate.value>=360)&&(t.options.rotate.value=0),c()})};var P=function(){var o=d.canvas.width/2,e=0;e=o-z.width*t.options.zoom.value/2,f={x:e,y:0},y={x:e,y:0}};t.resizeTo=function(o){if(null!=d.canvas&&null!=z){var e=(t.options,d.canvas.height/z.height),n=d.canvas.width/z.width;switch(z.isZoom||(e*=t.options.zoom.value,n*=t.options.zoom.value),o){case"width":t.options.zoom.value=n;break;case"height":t.options.zoom.value=e;break;case"page":default:t.options.zoom.value=Math.min(e,n)}t.$applyAsync(function(){t.options.zoom.value=Math.round(100*t.options.zoom.value)/100,t.options.controls.fit=o,z.isZoom?(P(),c()):(null!=z.refresh&&z.refresh(),P())})}},t.play=function(){null!=t.options.adsrc&&t.options.adsrc.start(0)},t.stop=function(){null!=t.options.adsrc&&t.options.adsrc.stop(0)},t.$watch(h,function(){u()},!0)}}}]);;
(function() {
    'use strict';

    angular
        .module('superChannelApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'ui.router.state.events',
            'ui.select',
            'infinite-scroll',
            'angular-timeline',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'CanvasViewer'
        ])
        .config(['uiSelectConfig' ,function(uiSelectConfig) {
            uiSelectConfig.theme = 'bootstrap';
        }])
        .config(['$locationProvider', function ($locationProvider) {
            $locationProvider.hashPrefix('');
        }])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('supervisor', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('statistics', {
            parent: 'supervisor',
            url: '/statistics',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/supervisor/statistics/statistics.html',
                    controller: 'StatisticsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statistics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('Statistics', Statistics);

    Statistics.$inject = ['$resource'];

    function Statistics ($resource) {
        var resourceUrl = 'api/statistics';

        var service = $resource(resourceUrl, {}, {
            'agents': {
                method: 'GET',
                isArray: true,
                url: resourceUrl + '/agents'
            },
            'chart': {
                method: 'POST'
            }
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('StatisticsController', StatisticsController);

    StatisticsController.$inject = ['Statistics', 'AlertService', '$sce', '$scope'];

    function StatisticsController(Statistics, AlertService, $sce, $scope) {
        var vm = this;
        var letters = '0123456789ABCDEF';
        var chart = null;

        vm.agents = [];
        vm.result = null;
        vm.series = [];

        vm.colors = vm.colorsByAgent = [];
        vm.labels = vm.labelsForTooltips = [];

        vm.multiple = {};
        vm.multiple.selected = [];
        vm.total = 0;

        vm.intervals = ["lastWeek", "lastMonth", "custom"];
        vm.interval = "lastMonth";

        vm.granularities = ["HOUR", "DAY", "MONTH"];
        vm.granularity = "DAY";

        vm.groupBy = '';
        vm.filterBy = [];

        vm.params = null;
        vm.fromGranularity = false;

        vm.changeInterval = changeInterval;
        vm.changeGranularity = changeGranularity;
        vm.getChart = getChart;

        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startPicker = false;
        vm.datePickerOpenStatus.endPicker = false;

        vm.startPicker = {
            date: generateLastWeekDate(),
            datepickerOptions: {
                maxDate: null
            }
        };
        vm.endPicker = {
            date: new Date(),
            datepickerOptions: {
                minDate: null
            }
        };

        loadAgents();
        changeInterval();

        function loadAgents() {
            Statistics.agents({}, onSuccess, onError);

            function onSuccess(response) {
                for (var i = 0; i < response.length; i++) {
                    vm.agents.push({name: response[i]});
                    vm.colorsByAgent.push({agent: response[i], color: getColor()});
                }
                vm.colors = [];
                getChart();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getChart() {
            if (!vm.fromGranularity) {

                vm.startPicker.date.setUTCHours(0, 0, 0, 0);
                vm.endPicker.date.setUTCHours(23, 59, 59, 999);

                vm.params = {
                    "granularity": vm.granularity,
                    "startDate": vm.startPicker.date,
                    "endDate": vm.endPicker.date
                };

                if (vm.groupBy == "AGENT") {
                    $.extend(vm.params, {groupBy: vm.groupBy});
                }

                if (vm.multiple.selected.length > 0) {
                    var agents = [];
                    vm.multiple.selected.forEach(function (elem) {
                        agents.push(elem.name);
                    });
                    $.extend(vm.params, {filterBy: agents});
                }
            }

            vm.result = null;
            vm.series = [];
            vm.labels = [];
            vm.labelsForTooltips = [];

            Statistics.chart(vm.params, onSuccess, onError);

            function onSuccess(result) {
                vm.fromGranularity = false;
                if (result !== null) {
                    vm.result = result;
                    vm.granularity = result.granularity;
                    vm.fromGranularity = false;
                    buildData();
                }
            };

            function onError(error) {
                vm.fromGranularity = false;
                vm.params = null;
                AlertService.error(error.data.message);
                vm.params = null;
            };
        };

        function buildData() {
            if (vm.groupBy === '') {
                vm.result.values.forEach(function (elem) {
                    //labels
                    var label = generateLabel(elem);

                    if (vm.series.length === 0) {
                        vm.series.push({"label": label, "data": [elem.total]});
                    } else {
                        vm.series[0].data.push(elem.total);
                    }

                });

                if (vm.colors.length === 0) {
                    vm.colors.push(getColor());
                }
                if (vm.series.length > 0) {
                    //Made like this due to error in test with PhantomJS
                    var colorArr = [];
                    for (var i = 0; i < vm.series[0].data.length; i++) {
                        colorArr.push(vm.colors[0]);
                    }
                    $.extend(vm.series[0], {"backgroundColor": colorArr});
                }
            } else {
                vm.result.values.forEach(function (elem) {
                    //Agents who have sessions in this period.
                    for (var agent in elem.groups) {
                        setElement(agent, elem.groups);
                    }

                    //Agents who have no sessions in this period, so the chart should show a 0.
                    var arr = vm.result.groups.filter(function (item) {
                        return !elem.groups.hasOwnProperty(item);
                    });
                    for (var j = 0; j < arr.length; j++) {
                        var agent = {};
                        agent[arr[j]] = 0;
                        setElement(arr[j], agent);
                    }
                });

                //Labels
                vm.result.values.forEach(function (elem) {
                    generateLabel(elem);
                });

                //colors
                for (var i = 0; i < vm.colorsByAgent.length; i++) {
                    for (var j = 0; j < vm.series.length; j++) {
                        if (vm.colorsByAgent[i].agent === vm.series[j].label) {
                            $.extend(vm.series[j], {"backgroundColor": new Array(vm.series[0].data.length).fill(vm.colorsByAgent[i].color)});
                        }
                    }
                }
            }

            vm.totalPerRow = [];
            vm.totalPerColumn = [];

            if (vm.series.length > 0) {
                //Made like this due to error in test with PhantomJS
                for (var i = 0; i < vm.series[0].data.length; i++) {
                    vm.totalPerColumn.push(0);
                }
            }

            vm.series.forEach(function (elem) {

                //Total per column
                for (var i = 0; i < elem.data.length; i++) {
                    vm.totalPerColumn[i] = (vm.totalPerColumn[i] + parseInt(elem.data[i]));
                }

                //Total per row
                vm.totalPerRow.push(elem.data.reduce(function (total, num) {
                    return total + parseInt(num);
                }, 0));

            });

            //Total of totals
            vm.total = vm.totalPerColumn.reduce(function (total, num) {
                return total + parseInt(num);
            }, 0);

            if (chart != null) {
                chart.destroy();
            }

            //This is necessary due to problems with hover events in chart.js
            $('#chart').remove();
            $('#chart_container').append('<canvas id="chart" class="chart chart-bar" chart-legend="true"></canvas>');
            //

            var ctx = document.getElementById("chart");
            chart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: vm.labels,
                    labelsForTooltips: vm.labelsForTooltips,
                    datasets: vm.series
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    legend: {
                        display: (vm.groupBy !== '')
                    },
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function (tooltipItems) {
                                return tooltipItems.yLabel;
                            }
                        }
                    }
                }
            });
        }

        function setElement(agent, value) {
            var elem = vm.series.filter(function (item) {
                return item.label === agent
            });
            if (elem.length === 0) {
                vm.series.push({"label": agent, "data": [value[agent]]});
            } else {
                elem[0].data.push(value[agent]);
            }
        }

        function generateStartOfDay() {
            var startOfDay = new Date();
            startOfDay.setHours(6);
            startOfDay.setMinutes(0);
            startOfDay.setSeconds(0);
            startOfDay.setMilliseconds(1);
            return startOfDay;
        }

        function generateLastWeekDate() {
            var d = new Date();
            d.setDate(d.getDate() - 7);
            return d;
        }

        function generateLastMonthDate() {
            var d = new Date();
            d.setMonth(d.getMonth() - 1);
            return d;
        }

        function getColor() {
            var color = '#';
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        }

        function generateLabel(elem) {
            var label = "";
            var tooltipLabel = "";
            switch (vm.granularity) {
                case "HOUR":
                    var time = elem.timePeriod.start.split('T')[1];
                    var hour = time.split(":")[0];
                    var date = elem.timePeriod.start.split('T')[0];
                    var day = date.split('-')[2];
                    var month = date.split('-')[1];
                    label = (day + '/' + month + ' ' + hour + ":00");
                    tooltipLabel = (date + ' ' + hour + ":00");
                    break;
                case "DAY":
                    var date = (elem.timePeriod.start.split('T')[0]);
                    label = tooltipLabel = date.split('-').reverse().join('/');
                    break;
                case "MONTH":
                    var date = elem.timePeriod.start.split("T")[0];
                    var list = date.split("-");
                    label = tooltipLabel = (list[1] + "/" + list[0]);
                    break;
            }
            //vm.labelsForTooltips.push(tooltipLabel);
            vm.labels.push(label);
            return label;
        }

        function openCalendar(picker) {
            vm.datePickerOpenStatus[picker] = true;
        };

        function changeGranularity(granularity) {
            vm.granularity = granularity;
            if (vm.series != []) {
                vm.params.granularity = granularity;
                vm.fromGranularity = true;
                getChart();
            }
        }

        function changeInterval() {
            var d = new Date();

            switch (vm.interval) {
                case "lastWeek":
                    vm.startPicker.date = generateLastWeekDate();
                    break;
                case "lastMonth":
                    vm.startPicker.date = generateLastMonthDate();
                    break;
                default:
                    vm.startPicker.date = generateStartOfDay();
                    break;
            }
            vm.endPicker.date = d;
        };

        var watchMinMaxValues = $scope.$watch(function () {
            return [vm.startPicker, vm.endPicker];
        }, function () {
            vm.startPicker.datepickerOptions.maxDate = vm.endPicker.date;
            vm.endPicker.datepickerOptions.minDate = vm.startPicker.date;
        }, true);

        $scope.trustAsHtml = function (value) {
            return $sce.trustAsHtml(value);
        };

        $scope.$on('$destroy', function () {
            watchMinMaxValues();
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('superadmin', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'superadmin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_SUPERADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/superadmin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/superadmin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'superadmin',
            url: '/logs',
            data: {
                authorities: ['ROLE_SUPERADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/superadmin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'superadmin',
            url: '/health',
            data: {
                authorities: ['ROLE_SUPERADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/superadmin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();
;
(function() {
    'use strict';

    angular.module('superChannelApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/superadmin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'superadmin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_SUPERADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/superadmin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'superadmin',
            url: '/audits',
            data: {
                authorities: ['ROLE_SUPERADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/superadmin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource', 'TenantService'];

    function PasswordResetInit($resource, TenantService) {
        var service = $resource('api/account/reset_password/init', {}, {
            'save': {
                method: 'POST',
                headers: { 'X-TenantID': TenantService.getFromUrl() }
            }
        });
        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource', 'TenantService'];

    function PasswordResetFinish($resource, TenantService) {
        var service = $resource('api/account/reset_password/finish', {}, {
            'save': {
                method: 'POST',
                headers: { 'X-TenantID': TenantService.getFromUrl() }
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'Register', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, Register, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            changeExpiredPassword: changeExpiredPassword
        };

        return service;

        function authorize(force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen(id) {
                var isAuthenticated = Principal.isAuthenticated();
                // an authenticated user can't access to home
                if (isAuthenticated && $rootScope.toState.parent === 'app' && ($rootScope.toState.name === 'home' && $rootScope.toStateParams.tenant)) {
                    if (id.authorities.indexOf('ROLE_AGENT') > -1) {
                        $state.go('session', {tenant: $rootScope.toStateParams.tenant});
                    }
                    if (id.authorities.indexOf('ROLE_ADMIN') > -1) {
                        $state.go('user-management', {tenant: $rootScope.toStateParams.tenant});
                    }
                    if (id.authorities.indexOf('ROLE_SUPERADMIN') > -1) {
                        $state.go('jhi-metrics', {tenant: $rootScope.toStateParams.tenant});
                    }
                    if (id.authorities.indexOf('ROLE_SUPERVISOR') > -1) {
                        $state.go('statistics', {tenant: $rootScope.toStateParams.tenant});
                    }
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    } else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('home', {tenant: $rootScope.toStateParams.tenant});
                    }
                }
            }
        }

        function changePassword(newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount(account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function changeExpiredPassword(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.changeExpiredPassword(credentials)
                .then(function (data) {
                    deferred.resolve(data);
                    return cb();
                })
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            return deferred.promise;
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                Principal.identity(true).then(function (account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account !== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout() {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish(keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit(reset, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(reset, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount(account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = {"name": previousStateName, "params": previousStateParams};
            $sessionStorage.previousState = previousState;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout,
            changeExpiredPassword: changeExpiredPassword
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                tenant: credentials.tenant,
                rememberMe: credentials.rememberMe,
                reCaptcha: credentials.reCaptcha
            };
            return $http.post('api/authenticate', data).then(authenticateSuccess);

            function authenticateSuccess (response) {
                var data = response.data;
                var status = response.status;
                var headers = response.headers;
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function changeExpiredPassword (credentials) {
            var data = {
                username: credentials.username,
                password: credentials.password,
                tenant: credentials.tenant,
                newPassword: credentials.newPassword
            };
            return $http.post('api/account/update_password', data);
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            $http.post('api/logout').then(function(response) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', '$scope', 'Auth', 'Principal', 'ProfileService', 'TenantService'];

    function NavbarController($state, $scope, Auth, Principal, ProfileService, TenantService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.currentTenant = TenantService.getFromUrl();
        vm.$state = $state;

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                if (account) {
                    vm.login = account.login;
                }
            });
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('404', {
                url: '/{tenant}/404',
                views: {
                    'navbar@': {
                        templateUrl: '404.html'
                    }
                }

            });

    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('login');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$rootScope', '$scope', 'Principal', '$state', '$location', '$timeout', '$uibModal', 'Auth', '$translate', 'VERSION', 'Captcha', 'GOOGLE_RECAPTCHA_KEY'];

    function HomeController($rootScope, $scope, Principal, $state, $location, $timeout, $uibModal, Auth, $translate, VERSION, Captcha, GOOGLE_RECAPTCHA_KEY) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = login;
        vm.requestResetPassword = requestResetPassword;
        vm.authenticationError = false;
        vm.captchaError = false;
        vm.reCaptchaResponse = null;
        vm.credentials = {};
        vm.password = null;
        vm.rememberMe = true;
        vm.tenant = extractTenantId();
        vm.username = null;
        vm.clear = clear;
        vm.version = VERSION;
        console.log("SuperChannel Version: " + vm.version);
        vm.dataSiteKey = GOOGLE_RECAPTCHA_KEY ? GOOGLE_RECAPTCHA_KEY : 'no-key';
        vm.isCaptchaEnabled = null;
        getCaptchaEnabled();

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        $timeout(function () {
            angular.element('#username').focus();
        });

        function getCaptchaEnabled() {
            var captchaRequest = Captcha.get(vm.tenant);
            captchaRequest.$promise.then(function (content) {
                vm.isCaptchaEnabled = content.captchaEnabled;
            })
        }

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if (vm.isAuthenticated()) {
                    $translate.use(account.langKey).then(function () {
                        $translate.refresh();
                        // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                        // since login is successful, go to stored previousState and clear previousState
                        if (Auth.getPreviousState()) {
                            var previousState = Auth.getPreviousState();
                            Auth.resetPreviousState();
                            $state.go(previousState.name, previousState.params);
                        } else {
                            if (vm.account.authorities.indexOf('ROLE_AGENT') > -1) {
                                $state.go('session');
                            } else if (vm.account.authorities.indexOf('ROLE_SUPERVISOR') > -1) {
                                $state.go('statistics');
                            } else if (vm.account.authorities.indexOf('ROLE_ADMIN') > -1) {
                                $state.go('user-management');
                            } else if (vm.account.authorities.indexOf('ROLE_SUPERADMIN') > -1) {
                                $state.go('jhi-metrics');
                            }
                        }
                    });
                }
            });
        }

        function login() {
            //Check grecaptcha only when enabled
            if (vm.isCaptchaEnabled === true) {
                vm.reCaptchaResponse = grecaptcha.getResponse();
            }

            if (vm.isCaptchaEnabled === true && vm.reCaptchaResponse && vm.reCaptchaResponse.length === 0) {
                vm.captchaError = true;
            } else {
                Auth.login({
                    username: vm.username,
                    password: vm.password,
                    tenant: vm.tenant,
                    rememberMe: vm.rememberMe,
                    reCaptcha: vm.reCaptchaResponse
                }).then(
                    function () {
                        vm.authenticationError = false;
                        $rootScope.$broadcast('authenticationSuccess');
                    }
                ).catch(
                    function (err) {
                        vm.authenticationError = true;
                        if (err.status === 400 && err.data.hasOwnProperty("ExpiredPassword")) {
                            vm.authenticationError = false;
                            open({
                                username: vm.username,
                                password: vm.password,
                                tenant: vm.tenant
                            });
                        }
                        if (err.data.hasOwnProperty("reCaptchaException")) {
                            vm.authenticationError = false;
                            vm.captchaError = true;
                        }
                        grecaptcha.reset();
                    });
            }
        }

        function newPassword(credentials) {
            vm.password = credentials.password;
            login();
        }


        function requestResetPassword() {
            $state.go('requestReset');
        }

        function extractTenantId() {
            var url = $location.url();
            if (url.indexOf('/') < 0)
                return null;
            else
                return url.split('/')[1];
        }

        function clear() {
            vm.authenticationError = false;
            vm.captchaError = null;
        }

        function open(credentials) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/components/expiredPassword/expired-password.html',
                controller: 'ExpiredPasswordController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('password');
                        return $translate.refresh();
                    }],
                    credentials: [function () {
                        return credentials;
                    }]
                }
            }).result.then(newPassword);
        }

    }
})();

;
(function () {
    'use strict';
    angular
        .module('superChannelApp')
        .factory('Captcha', Captcha);

    Captcha.$inject = ['$resource', 'TenantService'];

    function Captcha($resource, TenantService) {
        var resourceUrl = 'api/settings/captcha';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                headers: {'X-TenantID': TenantService.getFromUrl()},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('SessionExpirationController', SessionExpirationController);

    SessionExpirationController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'Session', 'VideoInitiate'];

    function SessionExpirationController($scope, $stateParams, $uibModalInstance, Session, VideoInitiate) {
        var vm = this;

        vm.sessionId = $stateParams.id;
        vm.clear = clear;
        vm.expire = expire;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function expire() {
            vm.isSaving = true;
            VideoInitiate.completeRoom({
                sessionId: vm.sessionId
            });
            Session.expiration({id: vm.sessionId}, {}, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $scope.$emit('superChannelApp:sessionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('SessionDialogController', SessionDialogController);

    SessionDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Session', 'AlertService', 'Principal'];

    function SessionDialogController($timeout, $scope, $uibModalInstance, entity, Session, AlertService, Principal) {
        var vm = this;

        vm.session = entity;
        vm.clear = clear;
        vm.save = save;
        vm.onChange = onChange;
        vm.alerts = AlertService.get();
        vm.selectedChannels = [];
        vm.isSaving = vm.invalidFormat = false;
        vm.sessionType = vm.session.target ? vm.session.target.toLowerCase() === "web" ? "web" : "sms" : "sms";

        //Placeholder to test external id
        vm.session.externalId = vm.session.externalId ? vm.session.externalId : null;

        Principal.identity().then(function (account) {
            vm.allowedChannels = account.allowedChannels;
        });

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
            channelPreselection();
        });


        function channelPreselection() {
            vm.session.selectedChannels.forEach(function (channel) {
                for (var i = 0; i < vm.allowedChannels.length; i++) {
                    if (vm.allowedChannels[i].name === channel) {
                        vm.selectedChannels[vm.allowedChannels[i].id] = true;
                    }
                }
            });
            if (vm.session.send && vm.session.send === "true") {
                save();
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function isPhoneNumberValid(phoneNumber) {
            return /^\+\d{10,13}$/.test(phoneNumber);
        }

        function onChange() {
            if (event.target.value.toString().toLowerCase() === 'web') {
                vm.session.target = 'web';
            } else {
                vm.session.target = "";
            }
        }

        function save() {
            vm.isSaving = true;
            if (vm.sessionType === 'sms') {
                if (!isPhoneNumberValid(vm.session.target)) {
                    if (vm.alerts.length <= 0) {
                        AlertService.error("superChannelApp.session.message.invalidformat");
                        vm.alerts = AlertService.get();
                    }
                    vm.invalidFormat = true;
                    vm.isSaving = false;
                    return;
                }
            }

            vm.session.channels = vm.allowedChannels.filter(function (elem) {
                return Object.keys(vm.selectedChannels).indexOf(elem.id.toString()) > -1 && vm.selectedChannels[elem.id.toString()]
            });
            Session.save(vm.session, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.session = result;
            $scope.$emit('superChannelApp:sessionUpdate', result);
            $uibModalInstance.close(result.id);
            vm.isSaving = vm.invalidFormat = false;
        }

        function onSaveError() {
            vm.isSaving = vm.invalidFormat = false;
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('SessionDetailController', SessionDetailController);

    SessionDetailController.$inject = ['$scope', '$rootScope', '$interval', 'previousState', 'entity', 'Timeline', 'Principal', '$state', '$uibModal', 'Session', 'AlertService', 'FileRestrictions', 'Item', '$q'];

    function SessionDetailController($scope, $rootScope, $interval, previousState, entity, Timeline, Principal, $state, $uibModal, Session, AlertService, FileRestrictions, Item) {
        var vm = this;
        var POOLING_TIME = 5000;
        var lastItem;
        var lastEvent;

        vm.session = entity;
        vm.previousState = previousState.name;
        vm.timelineList = Timeline.generateTimelineList(vm.session.items, vm.session.events);
        vm.itemCreationButtons = [];
        vm.createItem = createItem;
        lastItem = vm.session.items.slice().pop();
        lastEvent = vm.session.events.slice().pop();
        vm.expireSession = expireSession;
        vm.isExpired = (vm.session.end <= new Date());
        vm.dialogOpen = $rootScope.dialogOpen;

        var photoFileTypesArray = FileRestrictions.getPhotoFileTypes();
        var documentFileTypesArray = FileRestrictions.getDocumentFileTypes();
        var maxFileSizeInMB = FileRestrictions.getMaxFileSize();

        var photoLibraryTitles = Item.listContent({
            sessionId: vm.session.id,
            contentType: 'photo'
        });
        var documentLibraryTitles = Item.listContent({
            sessionId: vm.session.id,
            contentType: 'document'
        });
        var urlLibrary = Item.listContent({
            sessionId: vm.session.id,
            contentType: 'url'
        });

        vm.documentExtensions = '';
        vm.photoExtensions = '';

        documentFileTypesArray.$promise.then(function (types) {
            vm.documentExtensions = types.join(',');
        });
        photoFileTypesArray.$promise.then(function (types) {
            vm.photoExtensions = types.join(',');
        });

        vm.photoLibraryTitles = [];
        photoLibraryTitles.$promise.then(function (content) {
            vm.photoLibraryTitles = content;
        });

        vm.documentLibraryTitles = [];
        documentLibraryTitles.$promise.then(function (content) {
            vm.documentLibraryTitles = content;
        });

        vm.urlLibrary = [];
        urlLibrary.$promise.then(function (content) {
                vm.urlLibrary = content;
        });

        if (!vm.isExpired) {
            vm.updateTimeline = $interval(updateTimeline, POOLING_TIME);
        }

        Principal.identity().then(function (account) {
            for (var i = 0; i < account.allowedChannels.length; i++) {
                var button;
                switch (account.allowedChannels[i].itemContentType) {
                    case "PHOTO":
                        button = {
                            state: "session-detail.new-photo-item",
                            badge: "glyphicon glyphicon-picture"
                        };
                        break;
                    case "LOCATION":
                        button = {
                            state: "session-detail.new-location-item",
                            badge: "glyphicon glyphicon-map-marker"
                        };
                        break;
                    case "URL":
                        button = {
                            state: "session-detail.new-url-item",
                            badge: "glyphicon glyphicon-link"
                        };
                        break;
                    case "DOCUMENT":
                        button = {
                            state: "session-detail.new-document-item",
                            badge: "glyphicon glyphicon-paperclip"
                        };
                        break;
                    case "SKETCH":
                        button = {
                            state: "session-detail.new-document-item",
                            badge: "glyphicon glyphicon-pencil"
                        };
                        break;
                    case "VIDEO":
                        button = {
                            state: "session-detail.new-video-item",
                            badge: "glyphicon glyphicon-facetime-video"
                        };
                        break;
                }
                button.channel = account.allowedChannels[i];
                vm.itemCreationButtons.push(button);
            }
        });

        function updateTimeline() {
            Session.updates({
                id: vm.session.id,
                lastItem: lastItem ? lastItem.id : null,
                lastEvent: lastEvent ? lastEvent.id : null
            }, update, errorUpdate);

            function update(data) {
                var newElements = Timeline.generateTimelineList(data.items, data.events);
                newElements.reverse().forEach(function (element) {
                    vm.timelineList.unshift(element);
                });
                if (data.items.length > 0) {
                    AlertService.success("superChannelApp.session.newElement" + ((data.items.length > 1) ? 's' : ''), {param: data.items.length});
                }
                lastItem = (data.items.length > 0) ? data.items.pop() : lastItem;
                lastEvent = (data.events.length > 0) ? data.events.pop() : lastEvent;
            }

            function errorUpdate(error) {
                if (error.data && error.data.fieldErrors[0].message == 'expired') {
                    $state.reload();
                }
            }
        }

        function createItem(channel) {
            $rootScope.dialogOpen = true;
            vm.dialogOpen = true;
            $uibModal.open({
                templateUrl: 'app/entities/item/item-' + channel.itemContentType.toLowerCase() + '-dialog.html',
                controller: 'ItemDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            channel: channel.name,
                            type: channel.itemContentType,
                        };
                    },
                    sessionValues: function () {
                        return {
                            documentTitles: vm.documentLibraryTitles,
                            photoTitles: vm.photoLibraryTitles,
                            photoFileTypesArray: vm.photoExtensions,
                            documentFileTypesArray: vm.documentExtensions,
                            maxFileSizeInMB: maxFileSizeInMB,
                            urlLibrary: vm.urlLibrary
                        }
                    }
                }
            }).result.then(itemCreationSuccess, closeModal);
        }

        function expireSession() {
            $uibModal.open({
                templateUrl: 'app/entities/session/session-expiration-dialog.html',
                controller: 'SessionExpirationController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md'
            }).result.then(closeModal, closeModal);
        }

        function itemCreationSuccess() {
            AlertService.success("superChannelApp.item.created");
            closeModal();
        }

        function closeModal() {
            vm.dialogOpen = false;
            $state.go('session-detail', null, {reload: true});
        }

        var unsubscribe = $rootScope.$on('superChannelApp:sessionUpdate', function (event, result) {
            vm.session = result;
        });
        $scope.$on('$destroy', unsubscribe);
        $scope.$on('$destroy', function () {
            $interval.cancel(vm.updateTimeline);
        });
        $scope.$on('superChannelApp:sessionExpired', function () {
            Session.expiration({id: vm.session.id}, {}, function (result) {
                vm.session = result;
            });
        });
    }
})();


;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('session', {
                parent: 'entity',
                url: '/session?page&sort&search',
                data: {
                    authorities: ['ROLE_AGENT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/session/sessions.html',
                        controller: 'SessionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'start,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: PaginationUtil.parseSearch($stateParams.search)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('session');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('session-detail', {
                parent: 'entity',
                url: '/session/{id}',
                data: {
                    authorities: ['ROLE_AGENT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/session/session-detail.html',
                        controller: 'SessionDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('session');
                        $translatePartialLoader.addPart('item');
                        $translatePartialLoader.addPart('event');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Session', function ($stateParams, Session) {
                        return Session.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: 'session',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('sessionnew', {
                parent: 'session',
                url: '/new?target&channels&send&externalId',
                data: {
                    authorities: ['ROLE_AGENT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'PaginationUtil', function ($stateParams, $state, $uibModal, PaginationUtil) {
                    $uibModal.open({
                        templateUrl: 'app/entities/session/session-dialog.html',
                        controller: 'SessionDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    target: $stateParams.target,
                                    selectedChannels: PaginationUtil.parseChannels($stateParams.channels),
                                    send: $stateParams.send,
                                    externalId: $stateParams.externalId
                                };
                            }
                        }
                    }).result.then(function (id) {
                        $state.go('session-detail', {id: id});
                    }, function () {
                        $state.go('session');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('superChannelApp')
        .factory('Session', Session);

    Session.$inject = ['$resource', 'DateUtils'];

    function Session($resource, DateUtils) {
        var resourceUrl = 'api/sessions/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.start = DateUtils.convertDateTimeFromServer(data.start);
                        data.end = DateUtils.convertDateTimeFromServer(data.end);
                    }
                    return data;
                }
            },
            'expiration': {
                method: 'POST',
                url: resourceUrl + '/expiration'
            },
            'updates': {
                method: 'GET',
                url: resourceUrl + '/updates'
            },
        });


    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('SessionController', SessionController);

    SessionController.$inject = ['$rootScope', '$scope', '$state', '$translate', 'Session', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'PaginationUtil'];

    function SessionController($rootScope, $scope, $state, $translate, Session, ParseLinks, AlertService, pagingParams, paginationConstants, PaginationUtil) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.openCalendar = openCalendar;
        vm.search = search;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchParams = (pagingParams.search) ? pagingParams.search : null;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.end = false;
        vm.datePickerButtonBar = {
            show: true,
            today: {
                show: true,
                text: $translate.instant('global.datePickerButtons.today')
            },
            clear: {
                show: true,
                text: $translate.instant('global.datePickerButtons.clear')
            },
            date: {
                show: true,
                text: $translate.instant('global.datePickerButtons.date')
            },
            time: {
                show: true,
                text: $translate.instant('global.datePickerButtons.time')
            },
            close: {
                show: true,
                text: $translate.instant('global.datePickerButtons.close')
            }
        };

        loadAll();

        function loadAll() {
            var currentSearch = (vm.searchParams) ? vm.searchParams : {};
            Session.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sessionId: (currentSearch.sessionId === "") ? null : currentSearch.sessionId,
                agent: (currentSearch.agent === "") ? null : currentSearch.agent,
                target: (currentSearch.target === "") ? null : currentSearch.target,
                start: (currentSearch.start === "") ? null : currentSearch.start,
                end: (currentSearch.end === "") ? null : currentSearch.end,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sessions = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: PaginationUtil.joinSearch(vm.searchParams),
                tenant: $state.params.tenant
            });
        }

        function search() {
            vm.page = 1;
            transition();
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $rootScope.$on('$translateChangeSuccess', function () {
            vm.datePickerButtonBar.today.text = $translate.instant('global.datePickerButtons.today');
            vm.datePickerButtonBar.clear.text = $translate.instant('global.datePickerButtons.clear');
            vm.datePickerButtonBar.date.text = $translate.instant('global.datePickerButtons.date');
            vm.datePickerButtonBar.time.text = $translate.instant('global.datePickerButtons.time');
            vm.datePickerButtonBar.close.text = $translate.instant('global.datePickerButtons.close');
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('superChannelApp')
        .factory('VideoInitiate', VideoInitiate);

    VideoInitiate.$inject = ['$resource'];

    function VideoInitiate($resource) {
        var resourceUrl = 'api/sessions/:sessionId/:option';

        return $resource(resourceUrl, {}, {
            getVideoResource: {
                method: 'GET',
                isArray: true,
                params: {option: 'video'},
                transformResponse: function (data) {
                    if (data) {
                        data = data.split(",");
                    }
                    return data;
                }
            },
            completeRoom: {
                method: 'GET',
                isArray: true,
                params: {option: 'close'},
                transformResponse: function (data) {
                    if (data) {
                        data = data.split(",");
                    }
                    return data;
                }
            }

        });
    }
})();
;
/*!
 * Signature Pad v3.0.0-beta.3 | https://github.com/szimek/signature_pad
 * (c) 2018 Szymon Nowak | Released under the MIT license
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.SignaturePad = factory());
}(this, (function () { 'use strict';

  var Point = (function () {
      function Point(x, y, time) {
          this.x = x;
          this.y = y;
          this.time = time || Date.now();
      }
      Point.prototype.distanceTo = function (start) {
          return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
      };
      Point.prototype.equals = function (other) {
          return this.x === other.x && this.y === other.y && this.time === other.time;
      };
      Point.prototype.velocityFrom = function (start) {
          return (this.time !== start.time) ? this.distanceTo(start) / (this.time - start.time) : 0;
      };
      return Point;
  }());

  var Bezier = (function () {
      function Bezier(startPoint, control2, control1, endPoint, startWidth, endWidth) {
          this.startPoint = startPoint;
          this.control2 = control2;
          this.control1 = control1;
          this.endPoint = endPoint;
          this.startWidth = startWidth;
          this.endWidth = endWidth;
      }
      Bezier.fromPoints = function (points, widths) {
          var c2 = this.calculateControlPoints(points[0], points[1], points[2]).c2;
          var c3 = this.calculateControlPoints(points[1], points[2], points[3]).c1;
          return new Bezier(points[1], c2, c3, points[2], widths.start, widths.end);
      };
      Bezier.calculateControlPoints = function (s1, s2, s3) {
          var dx1 = s1.x - s2.x;
          var dy1 = s1.y - s2.y;
          var dx2 = s2.x - s3.x;
          var dy2 = s2.y - s3.y;
          var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
          var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };
          var l1 = Math.sqrt((dx1 * dx1) + (dy1 * dy1));
          var l2 = Math.sqrt((dx2 * dx2) + (dy2 * dy2));
          var dxm = (m1.x - m2.x);
          var dym = (m1.y - m2.y);
          var k = l2 / (l1 + l2);
          var cm = { x: m2.x + (dxm * k), y: m2.y + (dym * k) };
          var tx = s2.x - cm.x;
          var ty = s2.y - cm.y;
          return {
              c1: new Point(m1.x + tx, m1.y + ty),
              c2: new Point(m2.x + tx, m2.y + ty)
          };
      };
      Bezier.prototype.length = function () {
          var steps = 10;
          var length = 0;
          var px;
          var py;
          for (var i = 0; i <= steps; i += 1) {
              var t = i / steps;
              var cx = this.point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
              var cy = this.point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
              if (i > 0) {
                  var xdiff = cx - px;
                  var ydiff = cy - py;
                  length += Math.sqrt((xdiff * xdiff) + (ydiff * ydiff));
              }
              px = cx;
              py = cy;
          }
          return length;
      };
      Bezier.prototype.point = function (t, start, c1, c2, end) {
          return (start * (1.0 - t) * (1.0 - t) * (1.0 - t))
              + (3.0 * c1 * (1.0 - t) * (1.0 - t) * t)
              + (3.0 * c2 * (1.0 - t) * t * t)
              + (end * t * t * t);
      };
      return Bezier;
  }());

  function throttle(fn, wait) {
      if (wait === void 0) { wait = 250; }
      var previous = 0;
      var timeout = null;
      var result;
      var storedContext;
      var storedArgs;
      var later = function () {
          previous = Date.now();
          timeout = null;
          result = fn.apply(storedContext, storedArgs);
          if (!timeout) {
              storedContext = null;
              storedArgs = [];
          }
      };
      return function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
          }
          var now = Date.now();
          var remaining = wait - (now - previous);
          storedContext = this;
          storedArgs = args;
          if (remaining <= 0 || remaining > wait) {
              if (timeout) {
                  clearTimeout(timeout);
                  timeout = null;
              }
              previous = now;
              result = fn.apply(storedContext, storedArgs);
              if (!timeout) {
                  storedContext = null;
                  storedArgs = [];
              }
          }
          else if (!timeout) {
              timeout = window.setTimeout(later, remaining);
          }
          return result;
      };
  }

  var SignaturePad = (function () {
      function SignaturePad(canvas, options) {
          if (options === void 0) { options = {}; }
          var _this = this;
          this.canvas = canvas;
          this.options = options;
          this._handleMouseDown = function (event) {
              if (event.which === 1) {
                  _this._mouseButtonDown = true;
                  _this._strokeBegin(event);
              }
          };
          this._handleMouseMove = function (event) {
              if (_this._mouseButtonDown) {
                  _this._strokeMoveUpdate(event);
              }
          };
          this._handleMouseUp = function (event) {
              if (event.which === 1 && _this._mouseButtonDown) {
                  _this._mouseButtonDown = false;
                  _this._strokeEnd(event);
              }
          };
          this._handleTouchStart = function (event) {
              event.preventDefault();
              if (event.targetTouches.length === 1) {
                  var touch = event.changedTouches[0];
                  _this._strokeBegin(touch);
              }
          };
          this._handleTouchMove = function (event) {
              event.preventDefault();
              var touch = event.targetTouches[0];
              _this._strokeMoveUpdate(touch);
          };
          this._handleTouchEnd = function (event) {
              var wasCanvasTouched = event.target === _this.canvas;
              if (wasCanvasTouched) {
                  event.preventDefault();
                  var touch = event.changedTouches[0];
                  _this._strokeEnd(touch);
              }
          };
          this.velocityFilterWeight = options.velocityFilterWeight || 0.7;
          this.minWidth = options.minWidth || 0.5;
          this.maxWidth = options.maxWidth || 2.5;
          this.throttle = ('throttle' in options ? options.throttle : 16);
          this.minDistance = ('minDistance' in options ? options.minDistance : 5);
          if (this.throttle) {
              this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
          }
          else {
              this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
          }
          this.dotSize = options.dotSize || function () {
              return (this.minWidth + this.maxWidth) / 2;
          };
          this.penColor = options.penColor || 'black';
          this.backgroundColor = options.backgroundColor || 'rgba(0,0,0,0)';
          this.onBegin = options.onBegin;
          this.onEnd = options.onEnd;
          this._ctx = canvas.getContext('2d');
          this.clear();
          this.on();
      }
      SignaturePad.prototype.clear = function () {
          var ctx = this._ctx;
          var canvas = this.canvas;
          ctx.fillStyle = this.backgroundColor;
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          this._data = [];
          this._reset();
          this._isEmpty = true;
      };
      SignaturePad.prototype.fromDataURL = function (dataUrl, options, callback) {
          var _this = this;
          if (options === void 0) { options = {}; }
          var image = new Image();
          var ratio = options.ratio || window.devicePixelRatio || 1;
          var width = options.width || (this.canvas.width / ratio);
          var height = options.height || (this.canvas.height / ratio);
          this._reset();
          image.onload = function () {
              _this._ctx.drawImage(image, 0, 0, width, height);
              if (callback) {
                  callback();
              }
          };
          image.onerror = function (error) {
              if (callback) {
                  callback(error);
              }
          };
          image.src = dataUrl;
          this._isEmpty = false;
      };
      SignaturePad.prototype.toDataURL = function (type, encoderOptions) {
          if (type === void 0) { type = 'image/png'; }
          switch (type) {
              case 'image/svg+xml':
                  return this._toSVG();
              default:
                  return this.canvas.toDataURL(type, encoderOptions);
          }
      };
      SignaturePad.prototype.on = function () {
          this.canvas.style.touchAction = 'none';
          this.canvas.style.msTouchAction = 'none';
          if (window.PointerEvent) {
              this._handlePointerEvents();
          }
          else {
              this._handleMouseEvents();
              if ('ontouchstart' in window) {
                  this._handleTouchEvents();
              }
          }
      };
      SignaturePad.prototype.off = function () {
          this.canvas.style.touchAction = 'auto';
          this.canvas.style.msTouchAction = 'auto';
          this.canvas.removeEventListener('pointerdown', this._handleMouseDown);
          this.canvas.removeEventListener('pointermove', this._handleMouseMove);
          document.removeEventListener('pointerup', this._handleMouseUp);
          this.canvas.removeEventListener('mousedown', this._handleMouseDown);
          this.canvas.removeEventListener('mousemove', this._handleMouseMove);
          document.removeEventListener('mouseup', this._handleMouseUp);
          this.canvas.removeEventListener('touchstart', this._handleTouchStart);
          this.canvas.removeEventListener('touchmove', this._handleTouchMove);
          this.canvas.removeEventListener('touchend', this._handleTouchEnd);
      };
      SignaturePad.prototype.isEmpty = function () {
          return this._isEmpty;
      };
      SignaturePad.prototype.fromData = function (pointGroups) {
          var _this = this;
          this.clear();
          this._fromData(pointGroups, function (_a) {
              var color = _a.color, curve = _a.curve;
              return _this._drawCurve({ color: color, curve: curve });
          }, function (_a) {
              var color = _a.color, point = _a.point;
              return _this._drawDot({ color: color, point: point });
          });
          this._data = pointGroups;
      };
      SignaturePad.prototype.toData = function () {
          return this._data;
      };
      SignaturePad.prototype._strokeBegin = function (event) {
          var newPointGroup = {
              color: this.penColor,
              points: []
          };
          this._data.push(newPointGroup);
          this._reset();
          this._strokeUpdate(event);
          if (typeof this.onBegin === 'function') {
              this.onBegin(event);
          }
      };
      SignaturePad.prototype._strokeUpdate = function (event) {
          var x = event.clientX;
          var y = event.clientY;
          var point = this._createPoint(x, y);
          var lastPointGroup = this._data[this._data.length - 1];
          var lastPoints = lastPointGroup.points;
          var lastPoint = lastPoints.length > 0 && lastPoints[lastPoints.length - 1];
          var isLastPointTooClose = lastPoint ? point.distanceTo(lastPoint) <= this.minDistance : false;
          var color = lastPointGroup.color;
          if (!lastPoint || !(lastPoint && isLastPointTooClose)) {
              var curve = this._addPoint(point);
              if (!lastPoint) {
                  this._drawDot({ color: color, point: point });
              }
              else if (curve) {
                  this._drawCurve({ color: color, curve: curve });
              }
              lastPoints.push({
                  time: point.time,
                  x: point.x,
                  y: point.y
              });
          }
      };
      SignaturePad.prototype._strokeEnd = function (event) {
          this._strokeUpdate(event);
          if (typeof this.onEnd === 'function') {
              this.onEnd(event);
          }
      };
      SignaturePad.prototype._handlePointerEvents = function () {
          this._mouseButtonDown = false;
          this.canvas.addEventListener('pointerdown', this._handleMouseDown);
          this.canvas.addEventListener('pointermove', this._handleMouseMove);
          document.addEventListener('pointerup', this._handleMouseUp);
      };
      SignaturePad.prototype._handleMouseEvents = function () {
          this._mouseButtonDown = false;
          this.canvas.addEventListener('mousedown', this._handleMouseDown);
          this.canvas.addEventListener('mousemove', this._handleMouseMove);
          document.addEventListener('mouseup', this._handleMouseUp);
      };
      SignaturePad.prototype._handleTouchEvents = function () {
          this.canvas.addEventListener('touchstart', this._handleTouchStart);
          this.canvas.addEventListener('touchmove', this._handleTouchMove);
          this.canvas.addEventListener('touchend', this._handleTouchEnd);
      };
      SignaturePad.prototype._reset = function () {
          this._lastPoints = [];
          this._lastVelocity = 0;
          this._lastWidth = (this.minWidth + this.maxWidth) / 2;
          this._ctx.fillStyle = this.penColor;
      };
      SignaturePad.prototype._createPoint = function (x, y) {
          var rect = this.canvas.getBoundingClientRect();
          return new Point(x - rect.left, y - rect.top, new Date().getTime());
      };
      SignaturePad.prototype._addPoint = function (point) {
          var _lastPoints = this._lastPoints;
          _lastPoints.push(point);
          if (_lastPoints.length > 2) {
              if (_lastPoints.length === 3) {
                  _lastPoints.unshift(_lastPoints[0]);
              }
              var widths = this._calculateCurveWidths(_lastPoints[1], _lastPoints[2]);
              var curve = Bezier.fromPoints(_lastPoints, widths);
              _lastPoints.shift();
              return curve;
          }
          return null;
      };
      SignaturePad.prototype._calculateCurveWidths = function (startPoint, endPoint) {
          var velocity = (this.velocityFilterWeight * endPoint.velocityFrom(startPoint))
              + ((1 - this.velocityFilterWeight) * this._lastVelocity);
          var newWidth = this._strokeWidth(velocity);
          var widths = {
              end: newWidth,
              start: this._lastWidth
          };
          this._lastVelocity = velocity;
          this._lastWidth = newWidth;
          return widths;
      };
      SignaturePad.prototype._strokeWidth = function (velocity) {
          return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
      };
      SignaturePad.prototype._drawCurveSegment = function (x, y, width) {
          var ctx = this._ctx;
          ctx.moveTo(x, y);
          ctx.arc(x, y, width, 0, 2 * Math.PI, false);
          this._isEmpty = false;
      };
      SignaturePad.prototype._drawCurve = function (_a) {
          var color = _a.color, curve = _a.curve;
          var ctx = this._ctx;
          var widthDelta = curve.endWidth - curve.startWidth;
          var drawSteps = Math.floor(curve.length()) * 2;
          ctx.beginPath();
          ctx.fillStyle = color;
          for (var i = 0; i < drawSteps; i += 1) {
              var t = i / drawSteps;
              var tt = t * t;
              var ttt = tt * t;
              var u = 1 - t;
              var uu = u * u;
              var uuu = uu * u;
              var x = uuu * curve.startPoint.x;
              x += 3 * uu * t * curve.control1.x;
              x += 3 * u * tt * curve.control2.x;
              x += ttt * curve.endPoint.x;
              var y = uuu * curve.startPoint.y;
              y += 3 * uu * t * curve.control1.y;
              y += 3 * u * tt * curve.control2.y;
              y += ttt * curve.endPoint.y;
              var width = curve.startWidth + (ttt * widthDelta);
              this._drawCurveSegment(x, y, width);
          }
          ctx.closePath();
          ctx.fill();
      };
      SignaturePad.prototype._drawDot = function (_a) {
          var color = _a.color, point = _a.point;
          var ctx = this._ctx;
          var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;
          ctx.beginPath();
          this._drawCurveSegment(point.x, point.y, width);
          ctx.closePath();
          ctx.fillStyle = color;
          ctx.fill();
      };
      SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
          for (var _i = 0, pointGroups_1 = pointGroups; _i < pointGroups_1.length; _i++) {
              var group = pointGroups_1[_i];
              var color = group.color, points = group.points;
              if (points.length > 1) {
                  for (var j = 0; j < points.length; j += 1) {
                      var basicPoint = points[j];
                      var point = new Point(basicPoint.x, basicPoint.y, basicPoint.time);
                      this.penColor = color;
                      if (j === 0) {
                          this._reset();
                      }
                      var curve = this._addPoint(point);
                      if (curve) {
                          drawCurve({ color: color, curve: curve });
                      }
                  }
              }
              else {
                  this._reset();
                  drawDot({
                      color: color,
                      point: points[0]
                  });
              }
          }
      };
      SignaturePad.prototype._toSVG = function () {
          var _this = this;
          var pointGroups = this._data;
          var ratio = Math.max(window.devicePixelRatio || 1, 1);
          var minX = 0;
          var minY = 0;
          var maxX = this.canvas.width / ratio;
          var maxY = this.canvas.height / ratio;
          var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('width', this.canvas.width.toString());
          svg.setAttribute('height', this.canvas.height.toString());
          this._fromData(pointGroups, function (_a) {
              var color = _a.color, curve = _a.curve;
              var path = document.createElement('path');
              if (!isNaN(curve.control1.x) &&
                  !isNaN(curve.control1.y) &&
                  !isNaN(curve.control2.x) &&
                  !isNaN(curve.control2.y)) {
                  var attr = "M " + curve.startPoint.x.toFixed(3) + "," + curve.startPoint.y.toFixed(3) + " "
                      + ("C " + curve.control1.x.toFixed(3) + "," + curve.control1.y.toFixed(3) + " ")
                      + (curve.control2.x.toFixed(3) + "," + curve.control2.y.toFixed(3) + " ")
                      + (curve.endPoint.x.toFixed(3) + "," + curve.endPoint.y.toFixed(3));
                  path.setAttribute('d', attr);
                  path.setAttribute('stroke-width', (curve.endWidth * 2.25).toFixed(3));
                  path.setAttribute('stroke', color);
                  path.setAttribute('fill', 'none');
                  path.setAttribute('stroke-linecap', 'round');
                  svg.appendChild(path);
              }
          }, function (_a) {
              var color = _a.color, point = _a.point;
              var circle = document.createElement('circle');
              var dotSize = typeof _this.dotSize === 'function' ? _this.dotSize() : _this.dotSize;
              circle.setAttribute('r', dotSize.toString());
              circle.setAttribute('cx', point.x.toString());
              circle.setAttribute('cy', point.y.toString());
              circle.setAttribute('fill', color);
              svg.appendChild(circle);
          });
          var prefix = 'data:image/svg+xml;base64,';
          var header = '<svg'
              + ' xmlns="http://www.w3.org/2000/svg"'
              + ' xmlns:xlink="http://www.w3.org/1999/xlink"'
              + (" viewBox=\"" + minX + " " + minY + " " + maxX + " " + maxY + "\"")
              + (" width=\"" + maxX + "\"")
              + (" height=\"" + maxY + "\"")
              + '>';
          var body = svg.innerHTML;
          if (body === undefined) {
              var dummy = document.createElement('dummy');
              var nodes = svg.childNodes;
              dummy.innerHTML = '';
              for (var i = 0; i < nodes.length; i += 1) {
                  dummy.appendChild(nodes[i].cloneNode(true));
              }
              body = dummy.innerHTML;
          }
          var footer = '</svg>';
          var data = header + body + footer;
          return prefix + btoa(data);
      };
      return SignaturePad;
  }());

  return SignaturePad;

})));
;
var wrapper = document.getElementById("signature-pad");
if(wrapper != null){
    var clearButton = wrapper.querySelector("[data-action=clear]");
    var changeColorButton = wrapper.querySelector("[data-action=change-color]");
    var undoButton = wrapper.querySelector("[data-action=undo]");
    var savePNGButton = wrapper.querySelector("[data-action=save-png]");
    var saveJPGButton = wrapper.querySelector("[data-action=save-jpg]");
    var saveSVGButton = wrapper.querySelector("[data-action=save-svg]");
    var canvas = wrapper.querySelector("canvas");
    var signaturePad = new SignaturePad(canvas, {
        // It's Necessary to use an opaque color when saving image as JPEG;
        // this option can be omitted if only saving as PNG or SVG
        backgroundColor: 'rgb(255, 255, 255)'
    });

// Adjust canvas coordinate space taking into account pixel ratio,
// to make it look crisp on mobile devices.
// This also causes canvas to be cleared.
    function resizeCanvas() {
        // When zoomed out to less than 100%, for some very strange reason,
        // some browsers report devicePixelRatio as less than 1
        // and only part of the canvas is cleared then.
        var ratio =  Math.max(window.devicePixelRatio || 1, 1);

        // This part causes the canvas to be cleared
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);

        // This library does not listen for canvas changes, so after the canvas is automatically
        // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
        // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
        // that the state of this library is consistent with visual state of the canvas, you
        // have to clear it manually.
        signaturePad.clear();
    }

// On mobile devices it might make more sense to listen to orientation change,
// rather than window resize events.
    window.onresize = resizeCanvas;
    resizeCanvas();

    function download(dataURL, filename) {
        if (navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf("Chrome") === -1) {
            window.open(dataURL);
        } else {
            var blob = dataURLToBlob(dataURL);
            var url = window.URL.createObjectURL(blob);

            var a = document.createElement("a");
            a.style = "display: none";
            a.href = url;
            a.download = filename;

            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(url);
        }
    }

// One could simply use Canvas#toBlob method instead, but it's just to show
// that it can be done using result of SignaturePad#toDataURL.
    function dataURLToBlob(dataURL) {
        // Code taken from https://github.com/ebidel/filer.js
        var parts = dataURL.split(';base64,');
        var contentType = parts[0].split(":")[1];
        var raw = window.atob(parts[1]);
        var rawLength = raw.length;
        var uInt8Array = new Uint8Array(rawLength);

        for (var i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
        }

        return new Blob([uInt8Array], { type: contentType });
    }

    clearButton.addEventListener("click", function (event) {
        signaturePad.clear();
    });

    undoButton.addEventListener("click", function (event) {
        var data = signaturePad.toData();

        if (data) {
            data.pop(); // remove the last dot or line
            signaturePad.fromData(data);
        }
    });

    changeColorButton.addEventListener("click", function (event) {
        var r = Math.round(Math.random() * 255);
        var g = Math.round(Math.random() * 255);
        var b = Math.round(Math.random() * 255);
        var color = "rgb(" + r + "," + g + "," + b +")";

        signaturePad.penColor = color;
    });

    savePNGButton.addEventListener("click", function (event) {
        if (signaturePad.isEmpty()) {
            alert("Please provide a signature first.");
        } else {
            var dataURL = signaturePad.toDataURL();
            download(dataURL, "signature.png");
        }
    });

    saveJPGButton.addEventListener("click", function (event) {
        if (signaturePad.isEmpty()) {
            alert("Please provide a signature first.");
        } else {
            var dataURL = signaturePad.toDataURL("image/jpeg");
            download(dataURL, "signature.jpg");
        }
    });

    saveSVGButton.addEventListener("click", function (event) {
        if (signaturePad.isEmpty()) {
            alert("Please provide a signature first.");
        } else {
            var dataURL = signaturePad.toDataURL('image/svg+xml');
            download(dataURL, "signature.svg");
        }
    });
}

;
(function () {
        'use strict';

        angular
            .module('superChannelApp')
            .controller('ItemDialogController', ItemDialogController);

        ItemDialogController.$inject = ['$timeout', '$rootScope', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'sessionValues', 'Item', 'AlertService', 'DataUtils', 'FileRestrictions', 'VideoInitiate', 'ConnectParticipant', 'Session'];

        function ItemDialogController($timeout, $rootScope, $scope, $stateParams, $uibModalInstance, entity, sessionValues, Item, AlertService, DataUtils, FileRestrictions, VideoInitiate, ConnectParticipant, Session) {
            var vm = this;
            var alertError = [];
            AlertService.clear();

            var validUrlPattern = new RegExp(
                "^" +
                // protocol identifier
                "(?:(?:https?|ftp)://)" +
                // user:pass authentication
                "(?:\\S+(?::\\S*)?@)?" +
                "(?:" +
                // IP address exclusion
                // private & local networks
                "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
                "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
                "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
                // IP address dotted notation octets
                // excludes loopback network 0.0.0.0
                // excludes reserved space >= 224.0.0.0
                // excludes network & broacast addresses
                // (first & last IP address of each class)
                "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
                "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
                "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
                "|" +
                // host name
                "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
                // domain name
                "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
                // TLD identifier
                "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
                // TLD may end with dot
                "\\.?" +
                ")" +
                // port number
                "(?::\\d{2,5})?" +
                // resource path
                "(?:[/?#]\\S*)?" +
                "$", "i"
            );

            $timeout(function () {
                angular.element('.form-group:eq(1)>input').focus();
            });

            vm.item = entity;
            vm.sessionId = $stateParams.id;
            vm.clearPad = clearPad;
            vm.save = save;
            vm.redPen = redPen;
            vm.blackPen = blackPen;
            vm.clear = clear;
            var BYTES_IN_MB = 1048576;
            var dataURL;
            vm.photoLibraryTitles = sessionValues.photoTitles;
            vm.documentLibraryTitles = sessionValues.documentTitles;
            vm.urlLibrary = sessionValues.urlLibrary;

            vm.validUrlPattern = validUrlPattern;

            vm.showButtons = true;
            vm.isLocal = false;
            vm.isContentLibrary = false;
            vm.localUpload = localUpload;
            vm.contentLibrary = contentLibrary;

            function localUpload() {
                vm.isLocal = true;
                vm.isContentLibrary = false;
                vm.showButtons = false;
            }

            function contentLibrary() {
                vm.isLocal = false;
                vm.isContentLibrary = true;
                vm.showButtons = false;
            }

            $scope.toggle = true;
            $scope.$watch('toggle', function () {
                $scope.controlRoom = $scope.toggle ? 'Open Video Room' : 'Close Video Room';
            })

            function clear() {
                AlertService.clear();
                $rootScope.dialogOpen = false;
                $uibModalInstance.dismiss('cancel');
                vm.isLocal = false;
                vm.isContentLibrary = false;
                vm.showButtons = true;
            }

            function blackPen() {
                vm.isBlack = true;
                vm.isRed = false;
                signaturePad.penColor = "rgb(0, 0, 0)";
            }

            function redPen() {
                vm.isBlack = false;
                vm.isRed = true;
                signaturePad.penColor = "rgb(255, 0, 0)";
            }

            function clearPad() {
                signaturePad.clear();
            }

            function isEmpty() {
                return signaturePad.isEmpty();
            }

            function save() {
                var error = false;
                for (var i = 0; i < alertError.length; i++) {
                    AlertService.closeAlert(alertError[i].id);
                }
                alertError = [];
                vm.isSaving = true;
                if (vm.item.type === "URL") {
                    var urlInput = vm.item.content.url;
                    if (!urlInput.startsWith("http")) {
                        vm.item.content.url = "https://" + urlInput;
                    }
                    if (!validUrlPattern.test(vm.item.content.url)) {
                        alertError.push(AlertService.error("superChannelApp.item.url.help.url"));
                        error = true;
                    }
                }


                if (vm.item.type === "SKETCH") {
                    dataURL = signaturePad.toDataURL("image/jpeg");
                    vm.item.content = {};
                    vm.item.content.binaryData = dataURL;
                }


                if (vm.item.type === "VIDEO") {
                    vm.liveVideoActive ? stopLiveVideo() : startLiveVideo();
                } else {
                    var file = vm.item.content.binaryData;


                    if (file) {
                        var MAX_FILE_SIZE = sessionValues.maxFileSizeInMB.max * BYTES_IN_MB;
                        if (DataUtils.byteSize(file) > MAX_FILE_SIZE) {
                            alertError.push(AlertService.error("error.maxFileSize", {maxSize: MAX_FILE_SIZE / BYTES_IN_MB}));
                            error = true;
                        }
                        if (!DataUtils.getDataType(file).length > 0) {
                            alertError.push(AlertService.error("error.notValid"));
                            error = true;
                        }
                        if (vm.item.type === "PHOTO") {
                            if (sessionValues.photoFileTypesArray.indexOf((DataUtils.getDataType(file))) < 0) {
                                alertError.push(AlertService.error("error.invalidFormat"));

                            }
                        }
                        if (vm.item.type === "DOCUMENT") {
                            if (sessionValues.documentFileTypesArray.indexOf((DataUtils.getDataType(file))) < 0) {
                                alertError.push(AlertService.error("error.invalidFormat"));
                                error = true;
                            }
                        }
                    }
                    if (!error) {
                        if (!file && (vm.item.type === "PHOTO" || vm.item.type === "DOCUMENT")) {
                            // Doing content copy
                            Item.copyContent({sessionId: vm.sessionId}, {
                                    contentType: vm.item.type.toLowerCase(),
                                    filename: vm.item.content.key
                                },
                                onSaveSuccess, onSaveError);
                        } else if (vm.item.type !== "VIDEO") {
                            Item.save({sessionId: vm.sessionId}, vm.item, onSaveSuccess, onSaveError);
                        }
                    } else {
                        onSaveError();
                    }
                }

                function startLiveVideo() {
                    VideoInitiate.getVideoResource({
                        sessionId: vm.sessionId
                    }).$promise.then(function (token) {
                        var roomToken = token[0];
                        ConnectParticipant.connecting(roomToken);
                        vm.liveVideoActive = true;
                    }).catch(function (error) {
                        console.log('Error connecting to room', error);
                    });

                }

                function stopLiveVideo() {
                    vm.liveVideoActive = false;
                    ConnectParticipant.disconnectRoom();
                    clear();
                }

                function onSaveSuccess(result) {
                    AlertService.clear();
                    $rootScope.dialogOpen = false;
                    $uibModalInstance.close(result);
                    vm.isSaving = false;
                }

                function onSaveError() {
                    vm.isSaving = false;
                }
            }
        }
    }

)();
;
(function () {
    'use strict';
    angular
        .module('superChannelApp')
        .factory('Item', Item);

    Item.$inject = ['$resource', 'DateUtils'];

    function Item($resource, DateUtils) {
        var resourceUrl = 'api/sessions/:sessionId/items/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            listContent: {
                url: 'api/sessions/:sessionId/items/library/:contentType',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            copyContent: {
                url: 'api/sessions/:sessionId/items/library/copy/',
                method: 'POST'
            }
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('superChannelApp')
        .factory('FileRestrictions', FileRestrictions);

    FileRestrictions.$inject = ['$resource'];

    function FileRestrictions($resource) {
        var resourceUrl = 'api/fileRestrictions/:restrictionType';

        return $resource(resourceUrl, {}, {
            getPhotoFileExtensions: {
                method: 'GET',
                isArray: true,
                params: {restrictionType: 'photoFileExtensions'},
                transformResponse: function (data) {
                    if (data) {
                        data = data.split(",");
                    }
                    return data;
                }
            },
            getPhotoFileTypes: {
                method: 'GET',
                isArray: true,
                params: {restrictionType: 'photoFileTypes'},
                transformResponse: function (data) {
                    if (data) {
                        data = data.split(",");
                    }
                    return data;
                }
            },
            getDocumentFileExtensions: {
                method: 'GET',
                isArray: true,
                params: {restrictionType: 'documentFileExtensions'},
                transformResponse: function (data) {
                    if (data) {
                        data = data.split(",");
                    }
                    return data;
                }
            },
            getDocumentFileTypes: {
                method: 'GET',
                isArray: true,
                params: {restrictionType: 'documentFileTypes'},
                transformResponse: function (data) {
                    if (data) {
                        data = data.split(",");
                    }
                    return data;
                }
            },
            getMaxFileSize: {
                method: 'GET',
                isArray: false,
                params: {restrictionType: 'maxFileSize'},
                transformResponse: function (data) {
                    if (data) {
                        data = {max: parseInt(data, 10)};
                    }
                    return data;
                }
            }
        });
    }
})();
;
"use strict";

(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .service('ConnectParticipant', ConnectParticipant);

    function ConnectParticipant() {
        this.connecting = connecting;
        this.disconnectRoom = disconnectRoom;
        var activeRoom;

        function connecting(token) {
            var Video = Twilio.Video;
            Video.createLocalTracks({
                audio: false,
                video: false
            }).then(function (localTracks) {
                return Video.connect(
                    token,
                    {
                        tracks: localTracks
                    }
                ).then(function (room) {
                    activeRoom = room;

                    room.on('participantDisconnected', function () {
                        document.getElementById("local-media-div").innerHTML = null;
                    });

                    localTracks.forEach(function (track) {
                        document
                            .getElementById("local-media-div")
                            .appendChild(track.attach());
                    });

                    room.participants.forEach(function (participant) {

                        participant.tracks.forEach(function (publication) {
                            if (publication.isSubscribed) {
                                document.getElementById("local-media-div").innerHTML = null;
                                document
                                    .getElementById("local-media-div")
                                    .appendChild(publication.track.attach());
                            }
                        });

                        participant.on("trackSubscribed", function (track) {
                            if (document.getElementById("local-media-div")) {
                                document.getElementById("local-media-div").innerHTML = null;
                                document
                                    .getElementById("local-media-div")
                                    .appendChild(track.attach());
                            }
                        });
                    });

                    room.on(
                        "participantConnected",
                        function (participant) {
                            document.getElementById("local-media-div").innerHTML = null;
                            participant.tracks.forEach(function (publication) {
                                if (publication.isSubscribed) {
                                    var track = publication.track;
                                    document
                                        .getElementById("local-media-div")
                                        .appendChild(track.attach());
                                }
                            });
                            participant.on("trackSubscribed", function (track) {
                                document.getElementById("local-media-div").innerHTML = null;
                                document
                                    .getElementById("local-media-div")
                                    .appendChild(track.attach());
                            });
                        },
                        function (error) {
                            console.error(
                                "Unable to connect to Room", error.message
                            );
                        }
                    );

                });
            }).catch(function (error) {
                console.log("Caught error while connecting to room", error);
            });
        }

        function disconnectRoom() {
            document.getElementById("local-media-div").innerHTML = null;
            activeRoom.localParticipant.tracks.forEach(function (publication) {
                var attachedElements = publication.track.detach();
                attachedElements.forEach(function (element) {
                    return element.remove();
                });
            });
            // To disconnect from a Room
            activeRoom.disconnect();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
/**
 * Created by alejandro on 6/09/16.
 */
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('Timeline', Timeline);

    Timeline.$inject = ['$sce', 'EventCodeTranslator', 'GOOGLE_STATIC_MAPS_API'];

    function Timeline($sce, EventCodeTranslator, GOOGLE_STATIC_MAPS_API) {

        var CLIENT_SIDE = 'right';
        var AGENT_SIDE = 'left';

        var ERROR_BADGE = 'glyphicon glyphicon-exclamation-sign';
        var INFO_BADGE = 'glyphicon glyphicon-info-sign';

        var PHOTO_BADGE_ICON = 'glyphicon glyphicon-picture';
        var SKETCH_BADGE_ICON = 'glyphicon glyphicon-pencil';
        var URL_BADGE_ICON = 'glyphicon glyphicon-link';
        var LOCATION_BADGE_ICON = 'glyphicon glyphicon-map-marker';
        var DOCUMENT_BADGE_ICON = 'glyphicon glyphicon-paperclip';
        var DELETED_BADGE_ICON = 'glyphicon glyphicon-remove';

        var service = {
            generateTimelineList: generateTimelineList
        };

        return service;

        function setBadgeFromCode(timelineElement, code) {
            setBadge(timelineElement,
                EventCodeTranslator.isErrorEvent(code) ? 'warning' : 'success',
                EventCodeTranslator.isErrorEvent(code) ? ERROR_BADGE : INFO_BADGE);
        }

        function setBadge(timelineElement, badgeClass, badgeIcon) {
            timelineElement.badgeClass = badgeClass;
            timelineElement.badgeIconClass = badgeIcon;
        }

        function eventToTimelineElement(event) {
            var timelineElement = {
                side: (event.source === "AGENT") ? AGENT_SIDE : CLIENT_SIDE,
                timestamp: event.timestamp,
                msg: EventCodeTranslator.getMsg(event.code),
                translateValues: event.params
            };
            setBadgeFromCode(timelineElement, event.code);
            return timelineElement;
        }

        function itemToTimelineElement(item) {
            var timelineElement = {
                title: item.channel,
                timestamp: item.creationDate
            };
            switch (item.source) {
                case "CLIENT":
                    timelineElement.badgeClass = 'warning';
                    timelineElement.side = CLIENT_SIDE;
                    break;
                case "AGENT":
                    timelineElement.badgeClass = 'info';
                    timelineElement.side = AGENT_SIDE;
                    break;
            }
            if (item.content) {
                switch (item.type) {
                    case "PHOTO":
                        timelineElement.photoContent = $sce.trustAsHtml('<img src="' + item.content.url + '"/>');
                        timelineElement.badgeIconClass = PHOTO_BADGE_ICON;
                        timelineElement.photoUrl = item.content.url;
                        break;
                    case "SKETCH":
                        timelineElement.photoContent = $sce.trustAsHtml('<img src="' + item.content.url + '"/>');
                        timelineElement.badgeIconClass = SKETCH_BADGE_ICON;
                        timelineElement.photoUrl = item.content.url;
                        break;
                    case "LOCATION":
                        timelineElement.content = $sce.trustAsHtml('<a class="thumbnail" target="_blank" href="https://www.google.com/maps?q=' +
                            item.content.latitude + ',' + item.content.longitude +
                            '"><img src="https://maps.googleapis.com/maps/api/staticmap?center=' +
                            item.content.latitude + ',' + item.content.longitude +
                            '&amp;zoom=16&amp;size=600x300&amp;maptype=roadmap&amp;markers=color:blue%7Clabel:S%7C' +
                            item.content.latitude + ',' + item.content.longitude + '&amp;key=' + GOOGLE_STATIC_MAPS_API + '" width="100%" /></a>');
                        if (item.content.accuracy > 0) {
                            timelineElement.msg = 'superChannelApp.session.accuracy';
                            timelineElement.translateValues = {accuracy: item.content.accuracy};
                        }
                        timelineElement.badgeIconClass = LOCATION_BADGE_ICON;
                        break;
                    case "URL":
                        timelineElement.content = $sce.trustAsHtml('<a target="_blank" href="' + item.content.url + '">' + item.content.url + '</a>');
                        timelineElement.badgeIconClass = URL_BADGE_ICON;
                        break;
                    case "DOCUMENT":
                        timelineElement.content = $sce.trustAsHtml('<a target="_blank" href="' + item.content.url + '">' +
                            '<i class="' + DOCUMENT_BADGE_ICON + '"></i><span> ' + item.content.fileName + '</span></a>');
                        timelineElement.badgeIconClass = DOCUMENT_BADGE_ICON;
                        break;
                }
            } else {
                timelineElement.msg = 'superChannelApp.item.deletedContent';
                timelineElement.badgeIconClass = DELETED_BADGE_ICON;
            }
            return timelineElement;
        }

        function generateTimelineList(items, events) {
            var timelineList = [];
            for (var x = 0; x < items.length; x++) {
                timelineList.unshift(itemToTimelineElement(items[x]));
            }
            for (var i = 0; i < events.length; i++) {
                timelineList.unshift(eventToTimelineElement(events[i]));
            }
            timelineList.sort(function (elem1, elem2) {
                var date1 = new Date(elem1.timestamp).getTime();
                var date2 = new Date(elem2.timestamp).getTime();
                return (date1 > date2) ? -1 : (date1 < date2) ? 1 : 0;
            });
            return timelineList;
        }

    }
})();
;
/**
 * Service to retrieve from the URL the tenant
 * the front-end application is handling.
 * Created by Jorge on 20/12/16.
 */
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('TenantService', TenantService);

    TenantService.$inject = ['$location'];

    function TenantService($location) {

        var service = {
            getFromUrl: getFromUrl
        };

        return service;

        function getFromUrl() {
            var url = $location.url();
            if (url.indexOf('/') < 0)
                return null;
            else
                return url.split('/')[1];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function(){
    'use strict';

    angular
        .module('superChannelApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil() {

        var service = {
            parseAscending: parseAscending,
            parsePage: parsePage,
            parsePredicate: parsePredicate,
            parseSearch: parseSearch,
            joinSearch: joinSearch,
            parseChannels: parseChannels
        };

        return service;

        function parseAscending(sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1) {
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage(page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate(sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1) {
                sortArray.pop();
            }
            return sortArray.join(',');
        }

        function parseSearch(searchParams) {
            if (!searchParams) {
                return null;
            }
            var params = searchParams.split(',');
            return {
                sessionId: (params[0] === "") ? null : params[0],
                agent: (params[1] === "") ? null : params[1],
                target: (params[2] === "") ? null : params[2],
                start: (params[3] === "") ? null : new Date(params[3]),
                end: (params[4] === "") ? null : new Date(params[4])
            }
        }

        function joinSearch(searchParams) {
            if (!searchParams) {
                return null;
            } else {
                var query = ((searchParams.sessionId) ? searchParams.sessionId : "")
                    + ',' + ((searchParams.agent) ? searchParams.agent : "" )
                    + ',' + ((searchParams.target) ? searchParams.target : "" )
                    + ',' + ((searchParams.start) ? searchParams.start : "" )
                    + ',' + ((searchParams.end) ? searchParams.end : "");
                return (query === ",,,,") ? null : query;
            }
        }

        function parseChannels(channels) {
            if (!channels) {
                return [];
            }
            return channels.split(',');
        }
    }
})();
;
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    '<span translate="global.pagination.showing">Showing </span> ' +
                    '{{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    '<span translate="global.pagination.of">of </span> ' +
                    '{{$ctrl.queryCount}} <span translate="global.pagination.items">items </span>' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('superChannelApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
/**
 * Created by alejandro on 6/09/16.
 */
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('EventCodeTranslator', EventCodeTranslator);

    function EventCodeTranslator() {

        var service = {
            getMsg: getMsg,
            isErrorEvent: isErrorEvent
        };

        return service;

        function isErrorEvent(code) {
            return ((code + '')[0] === '3' || (code + '')[0] === '4');
        }

        function getMsg(code) {
            var msgName;
            switch (code) {
                //1xx: Client information
                case 101:
                    msgName = "clientLogin";
                    break;
                //2xx: Session information
                case 201:
                    msgName = "sessionCreated";
                    break;
                //3xx: Client error
                case 301:
                    msgName = "locationError";
                    break;
                case 203:
                    msgName = "videoSession";
                    break;
                //4xx: Session error
                //NO SESSION ERROR CODES YET.
            }
            return 'superChannelApp.event.msg.' + msgName;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64,
            getDataType: getDataType
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            return size(base64String);
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }

        function getDataType (base64String) {
            return base64String.split(',')[0].split(':')[1].split(';')[0];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('superChannelApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'nl',
            'fr',
            'it',
            'es'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .constant('paginationConstants', {
            'itemsPerPage': 10
        });
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .directive('appFilereader', appFilereader);

    appFilereader.$inject = ['$q'];

    function appFilereader($q) {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };
        var slice = Array.prototype.slice;

        return directive;
        function linkFunc(scope, element, attrs, ngModel) {
            if (!ngModel) return;

            ngModel.$render = function () {
            };

            element.bind('change', function (e) {
                var element = e.target;

                $q.all(slice.call(element.files, 0).map(readFile))
                    .then(function (values) {
                        if (element.multiple) ngModel.$setViewValue(values);
                        else ngModel.$setViewValue(values.length ? values[0] : null);
                    });

                function readFile(file) {
                    var deferred = $q.defer();

                    var reader = new FileReader();
                    reader.onload = function (e) {
                        deferred.resolve(e.target.result);
                    };
                    reader.onerror = function (e) {
                        deferred.reject(e);
                    };
                    reader.readAsDataURL(file);

                    return deferred.promise;
                }

            }); //change

        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('ExpiredPasswordController', ExpiredPasswordController);

    ExpiredPasswordController.$inject = ['Auth', '$uibModalInstance', 'credentials'];

    function ExpiredPasswordController(Auth, $uibModalInstance, credentials) {
        var vm = this;

        vm.clear = clear;
        vm.changeExpiredPassword = changeExpiredPassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.account = null;
        vm.samePassword = null;
        vm.close = close;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function close () {
            vm.doNotMatch = vm.samePassword = vm.error = null;
        }

        function changeExpiredPassword() {
            if (vm.password !== vm.confirmPassword) {
                vm.error = vm.success = vm.samePassword = null;
                vm.doNotMatch = 'ERROR';
            } else if (vm.password === credentials.password) {
                vm.error = vm.success = vm.doNotMatch = null;
                vm.samePassword = 'ERROR';
            } else {
                vm.doNotMatch = null;
                credentials.newPassword = vm.password;
                Auth.changeExpiredPassword(credentials).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                    credentials.password = credentials.newPassword;
                    $uibModalInstance.close(credentials);
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .directive('countdown', countdown);

    countdown.$inject = ['$interval'];

    function countdown ($interval) {
        // return the directive link function. (compile function not needed)
        return function(scope, element, attrs, $rootScope) {
            var endTime,
                stopTime,
                isExpired;

            // used to update the UI
            function updateTime() {
                var ms = endTime.getTime() - new Date().getTime();
                if (ms > 0) {
                    var min = Math.floor(ms/1000/60),
                        sec = Math.floor((ms/1000) % 60 );
                    sec= ('0' + sec).slice(-2);
                    var timeleft = min + ':' + sec;
                    element.text(timeleft);
                } else {
                    if (!isExpired) {
                        $interval.cancel(stopTime);
                        $rootScope.$broadcast('superChannelApp:sessionExpired');
                    }
                }
            }

            scope.$watch(attrs.isExpired, function() {
                isExpired = scope.$eval(attrs.isexpired);
            });

            scope.$watch(attrs.endTime, function() {
                endTime = scope.$eval(attrs.endtime);
                updateTime();
            });

            stopTime = $interval(updateTime, 1000);

            // listen on DOM destroy (removal) event, and cancel the next UI update
            // to prevent updating time after the DOM element was removed.
            element.on('$destroy', function() {
                $interval.cancel(stopTime);
            });
        };
    }

})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('canvas', {
                url: '/{tenant}/canvas/{photo}',
                data: {
                    authorities: []
                },
                views: {
                    'navbar@': {
                        templateUrl: 'app/components/canvasViewer/canvas-viewer.html',
                        controller: 'CanvasViewerController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('CanvasViewerController', CanvasViewerController);

    CanvasViewerController.$inject = ['$stateParams'];

    function CanvasViewerController($stateParams) {
        var vm = this;

        vm.fileInput = $stateParams.photo;
        vm.options = {
            controls : {
                toolbar : true,
                fit : 'page'
            }
        };
    }
})();
;
(function () {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
            '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
            '</div>' +
            '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('superChannelApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert(message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('superChannelApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
                // connection refused, server not reachable
                case 0:
                    addErrorAlert('Server not reachable', 'error.serverNotReachable');
                    break;

                case 400:
                    var errorHeader = httpResponse.headers('X-superChannelApp-error');
                    var entityKey = httpResponse.headers('X-superChannelApp-params');
                    if (errorHeader) {
                        var entityName = $translate.instant('global.menu.entities.' + entityKey);
                        addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                    } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                        for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                            var fieldError = httpResponse.data.fieldErrors[i];
                            // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                            var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                            var fieldName = $translate.instant('superChannelApp.' + fieldError.objectName + '.' + convertedField);
                            addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                        }
                    } else if (httpResponse.data && httpResponse.data.message) {
                        addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                    } else {
                        addErrorAlert(httpResponse.data);
                    }
                    break;

                case 404:
                    addErrorAlert('Not found', 'error.urlNotFound');
                    break;
                case 405:
                    addErrorAlert('Delivery failure', 'error.deliveryError');
                    break;
                case 500:
                    addErrorAlert('Server doesn\'t respond', 'error.serverError');
                    break;

                case 503:
                    addErrorAlert('Service unavailable', 'error.serviceUnavailable');
                    break;

                default:
                    addErrorAlert('Ops! An error occurred trying to connect to Superchannel service. Try again later.', 'error.uncontrolledError');
            }
        });

        $scope.$on('$destroy', function () {
            if (angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null) {
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" ng-show="$ctrl.isDialogAlert || (!$ctrl.isDialogAlert && !$ctrl.isDialogOpen())">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('superChannelApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', '$rootScope', 'AlertService'];

    function jhiAlertController($scope, $rootScope, AlertService) {
        var vm = this;

        vm.isDialogOpen = isDialogOpen;
        function isDialogOpen() {
            return $rootScope.dialogOpen;
        }
        vm.isDialogAlert = $rootScope.dialogOpen ? true : false;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-superChannelApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-superChannelApp-params')});
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('superChannelApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$localStorage', '$sessionStorage'];

    function authInterceptor ($localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token && (config.url.indexOf('api/') === 0 || config.url.indexOf('management/') === 0)) {
                config.headers.Authorization = 'Bearer ' + token;
            }

            return config;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('apiUrlInterceptor', apiUrlInterceptor);

    apiUrlInterceptor.$inject = ['API_URL'];

    function apiUrlInterceptor (API_URL) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            if (config.url.match("^api/|^management/|^swagger-resources/")) {
                config.url = API_URL + config.url;
            }

            return config;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendenc
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                if (title) {
                    $window.document.title = title;
                }
            }).catch(
                function (reason) {
                    // Error in translation here. Seems to be on initial load only.
                    // console.log("Translation rejected: " + JSON.stringify(reason));
                })
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }


                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$window', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $window, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            var browserLang = ($window.navigator.language || $window.navigator.userLanguage).split('-')[0];
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1 && LANGUAGES.indexOf(browserLang) !== -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to language "' + browserLang + '"');
                $cookies.putObject(name, browserLang);
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {

        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/error/404');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('apiUrlInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            url: '/{tenant}',
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {

                tenant: ['$stateParams', function ($stateParams) {
                    return $stateParams.tenant;
                }],
                authorize: ['Auth', function (Auth) {
                    return Auth.authorize();
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
// DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
(function () {
    'use strict';
    angular
        .module('superChannelApp')
        .constant('VERSION', "3.3.0")
        .constant('GOOGLE_STATIC_MAPS_API', "AIzaSyDRzwFUpA-G2JVTYfLv8K9QSuE4h6PMXEE")
;
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService', 'Channel'];

    function UserManagementDialogController($stateParams, $uibModalInstance, entity, User, JhiLanguageService, Channel) {
        var vm = this;

        vm.authorities = ['ROLE_AGENT', 'ROLE_ADMIN', 'ROLE_SUPERVISOR'];
        vm.channels = [];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Channel.query(function (channels) {
            vm.channels = channels;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management-new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management-edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ["ROLE_AGENT", "ROLE_ADMIN"];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                tenant: $state.params.tenant
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .directive('startsWith', function() {
            return {
                require: 'ngModel',
                link: function(scope, element, attr, mCtrl) {
                    function validateStartsWith(value) {
                        mCtrl.$setValidity('startswith', (value.length === 0) || !attr.startsWith || (value.indexOf(attr.startsWith) === 0));
                        return value;
                    }
                    return mCtrl.$parsers.push(validateStartsWith);
                }
            }
        });
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('setting', {
            parent: 'admin',
            url: '/setting',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/setting/settings.html',
                    controller: 'SettingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('setting');
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';
    angular
        .module('superChannelApp')
        .factory('Setting', Setting);

    Setting.$inject = ['$resource'];

    function Setting ($resource) {
        var resourceUrl =  'api/settings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' , isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('SettingController', SettingController);

    SettingController.$inject = ['$scope', '$state', 'Setting'];

    function SettingController($scope, $state, Setting) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.smsContent = {};
        vm.smsFrom = {};
        vm.tenantLanguage = {};
        vm.expirationTime = {};
        vm.mailDomain = {};
        vm.sessionDomain = {};
        vm.callbackUrl = {};
        vm.captchaEnabled = {};
        vm.success = null;
        vm.captchaEnabledOptions = ['true', 'false'];

        loadAll();

        function loadAll() {
            Setting.query(function (result) {
                for (var i = 0; i < result.length; i++) {
                    if (result[i].settingKey === 'smsContent') {
                        vm.smsContent = result[i];
                    } else if (result[i].settingKey === 'smsFrom') {
                        vm.smsFrom = result[i];
                    } else if (result[i].settingKey === 'tenantLanguage') {
                        vm.tenantLanguage = result[i];
                    } else if (result[i].settingKey === 'expirationTime') {
                        vm.expirationTime = result[i];
                        vm.expirationTime.settingValue = Number(vm.expirationTime.settingValue);
                    } else if (result[i].settingKey === 'mailDomain') {
                        vm.mailDomain = result[i];
                    } else if (result[i].settingKey === 'sessionDomain') {
                        vm.sessionDomain = result[i];
                    } else if (result[i].settingKey === 'callbackUrl') {
                        vm.callbackUrl = result[i];
                    } else if (result[i].settingKey === 'captchaEnabled') {
                        vm.captchaEnabled = result[i];
                    }
                }
            });
        }

        function save() {
            var settings = [vm.smsContent, vm.smsFrom, vm.tenantLanguage, vm.expirationTime, vm.mailDomain, vm.sessionDomain, vm.callbackUrl, vm.captchaEnabled];
            Setting.update(settings, function () {
                vm.error = null;
                vm.success = 'OK';
            }, function () {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html',
                    controller: 'DocsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('DocsController', DocsController);

    DocsController.$inject = ['API_URL'];
    function DocsController(API_URL) {
        var vm = this;

        vm.frameRef = "swagger-ui/index.html#"+encodeURIComponent(API_URL);
    }

})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('ChannelDialogController', ChannelDialogController);

    ChannelDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Channel'];

    function ChannelDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Channel) {
        var vm = this;

        vm.channel = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.channel.id !== null) {
                Channel.update(vm.channel, onSaveSuccess, onSaveError);
            } else {
                Channel.save(vm.channel, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('superChannelApp:channelUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('ChannelDetailController', ChannelDetailController);

    ChannelDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Channel'];

    function ChannelDetailController($scope, $rootScope, $stateParams, previousState, entity, Channel) {
        var vm = this;

        vm.channel = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('superChannelApp:channelUpdate', function(event, result) {
            vm.channel = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('channel', {
            parent: 'admin',
            url: '/channel?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/channel/channels.html',
                    controller: 'ChannelController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('channel');
                    $translatePartialLoader.addPart('itemContentType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('channel-detail', {
            parent: 'admin',
            url: '/channel/{id}',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/channel/channel-detail.html',
                    controller: 'ChannelDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('channel');
                    $translatePartialLoader.addPart('itemContentType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Channel', function($stateParams, Channel) {
                    return Channel.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'channel',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('channel-detail-edit', {
            parent: 'channel-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/channel/channel-dialog.html',
                    controller: 'ChannelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Channel', function(Channel) {
                            return Channel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('channel-new', {
            parent: 'channel',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/channel/channel-dialog.html',
                    controller: 'ChannelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                itemContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('channel', null, { reload: true });
                }, function() {
                    $state.go('channel');
                });
            }]
        })
        .state('channel-edit', {
            parent: 'channel',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/channel/channel-dialog.html',
                    controller: 'ChannelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Channel', function(Channel) {
                            return Channel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('channel', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('superChannelApp')
        .factory('Channel', Channel);

    Channel.$inject = ['$resource'];

    function Channel ($resource) {
        var resourceUrl =  'api/channels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('ChannelController', ChannelController);

    ChannelController.$inject = ['$scope', '$state', 'Channel', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ChannelController ($scope, $state, Channel, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Channel.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.channels = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                tenant: $state.params.tenant
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_AGENT', 'ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'Captcha', 'GOOGLE_RECAPTCHA_KEY'];

    function RequestResetController($timeout, Auth, Captcha, GOOGLE_RECAPTCHA_KEY) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;
        vm.clear = clear;
        vm.dataSiteKey = GOOGLE_RECAPTCHA_KEY;
        vm.isCaptchaEnabled = null;
        getCaptchaEnabled();

        $timeout(function () {
            angular.element('#email').focus();
        });

        function clear() {
            vm.error = null;
            vm.errorEmailNotExists = null;
            vm.captchaError = null;
            vm.success = null;
        }

        function getCaptchaEnabled() {
            var captchaRequest = Captcha.get(vm.tenant);
            captchaRequest.$promise.then(function (content) {
                vm.isCaptchaEnabled = content.captchaEnabled;
            })
        }

        function requestReset() {

            vm.reCaptchaResponse = grecaptcha.getResponse();

            vm.error = null;
            vm.errorEmailNotExists = null;
            vm.captchaError = null;

            if (vm.reCaptchaResponse.length === 0 && vm.isCaptchaEnabled === true) {
                vm.captchaError = true;
            } else {
                Auth.resetPasswordInit(
                    {
                        email: vm.resetAccount.email,
                        reCaptcha: vm.reCaptchaResponse
                    }
                ).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'e-mail address not registered') {
                        vm.errorEmailNotExists = 'ERROR';
                    } else if (response.status === 401 && response.data === 'reCaptcha Exception') {
                        vm.captchaError = true;
                        vm.success = null;
                    } else {
                        vm.error = 'ERROR';
                    }
                    grecaptcha.reset();
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', '$state', 'Auth'];

    function ResetFinishController ($stateParams, $timeout, $state, Auth) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = login;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function login() {
            $state.go('home');
        }

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 8) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_AGENT', 'ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController(Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function (account) {
            vm.account = account;
        });

        function changePassword() {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;(function(){'use strict';angular.module('superChannelApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<script src="https://www.google.com/recaptcha/api.js" async defer="defer"></script><div ng-cloak class="row row-app"><div class="container"><div class="col-app"><div class="login"><div class="panel panel-default col-sm-4 col-sm-offset-4" ng-show="!vm.isAuthenticated()"><div class="panel-body"><div class="alert alert-danger" ng-show="vm.authenticationError"><button type="button" class="close" ng-click="vm.clear()" aria-hidden="true">\xD7</button><div translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="alert alert-danger" ng-show="vm.captchaError"><button type="button" class="close" ng-click="vm.clear()" aria-hidden="true">\xD7</button><div translate="login.messages.error.captcha"><strong>Captcha could not be validated!</strong></div></div><form role="form" ng-submit="vm.login()"><div class="form-group"><label for="username" translate="global.form.username">Login</label> <input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username" autocomplete="username"></div><div class="form-group"><label for="password" translate="login.form.password">Password</label> <input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password" autocomplete="current-password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span translate="login.form.rememberme">Remember me</span></label></div><div class="form-group"><div ng-show="vm.isCaptchaEnabled" class="g-recaptcha" data-theme="light" data-sitekey="{{vm.dataSiteKey}}"></div></div><button type="submit" class="btn btn-primary btn-block" translate="login.form.button">Login</button><p></p><br><div><a class="alert-link" href="" ng-click="vm.requestResetPassword()" translate="login.password.forgot">Did you forget your password?</a></div><div><p style="font-size: 7pt; color: lightgrey;">Version {{vm.version}}</p></div></form></div></div><div class="clearfix"></div></div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div class="alert alert-danger" ng-show="vm.captchaNotValidated">Captcha not validated!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label> <input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 8 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.pattern" translate="global.messages.validate.newpassword.pattern">Your password is required to have uppercase, lowercase and numbers.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 8 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.pattern" translate="global.messages.validate.confirmpassword.pattern">Your password is required to have uppercase, lowercase and numbers.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" translate="settings.form.firstname">First Name</label> <input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" translate="settings.form.lastname">Last Name</label> <input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label> <input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" translate="settings.form.language">Language</label> <select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/channel/channel-detail.html','<div><h2><span translate="superChannelApp.channel.detail.title">Channel</span> {{vm.channel.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="superChannelApp.channel.name">Name</span></dt><dd><span>{{vm.channel.name}}</span></dd><dt><span translate="superChannelApp.channel.itemContentType">Item Content Type</span></dt><dd><span translate="{{\'superChannelApp.ItemContentType.\' + vm.channel.itemContentType}}">{{vm.channel.itemContentType}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="channel-detail-edit({id:vm.channel.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/admin/channel/channel-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 ng-show="!vm.channel.id" class="modal-title" id="myChannelCreateLabel" translate="superChannelApp.channel.home.createLabel">Create a Channel</h4><h4 ng-show="vm.channel.id" class="modal-title" id="myChannelEditLabel" translate="superChannelApp.channel.home.editLabel">Edit a Channel</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" translate="superChannelApp.channel.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" maxlength="20" ng-model="vm.channel.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.channel.id"><label for="itemContentType" translate="superChannelApp.channel.itemContentType">Item Content Type</label> <input type="text" class="form-control" id="itemContentType" name="itemContentType" placeholder="{{ \'superChannelApp.ItemContentType.\' + vm.channel.itemContentType | translate}}" readonly="readonly"></div><div class="form-group" ng-if="!vm.channel.id"><label class="control-label" translate="superChannelApp.channel.itemContentType" for="field_itemContentType">Item Content Type</label> <select class="form-control" name="itemContentType" ng-model="vm.channel.itemContentType" id="field_itemContentType" required><option value="PHOTO" translate="superChannelApp.ItemContentType.PHOTO">photo</option><option value="DOCUMENT" translate="superChannelApp.ItemContentType.DOCUMENT">document</option><option value="URL" translate="superChannelApp.ItemContentType.URL">url</option><option value="LOCATION" translate="superChannelApp.ItemContentType.LOCATION">location</option><option value="VIDEO" translate="superChannelApp.ItemContentType.VIDEO">video</option></select><div ng-show="editForm.itemContentType.$invalid"><p class="help-block" ng-show="editForm.itemContentType.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/channel/channels.html','<div><h2 translate="superChannelApp.channel.home.title">Channels</h2><jhi-alert></jhi-alert><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span translate="superChannelApp.channel.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="itemContentType"><span translate="superChannelApp.channel.itemContentType">Item Content Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="channel in vm.channels track by channel.id"><td><a ui-sref="channel-detail({id:channel.id})">{{channel.id}}</a></td><td>{{channel.name}}</td><td translate="{{\'superChannelApp.ItemContentType.\' + channel.itemContentType}}">{{channel.itemContentType}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="channel-edit({id:channel.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="{{vm.frameRef}}" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/setting/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate="superChannelApp.setting.home.title">Settings</h2><div class="alert alert-success" ng-show="vm.success" translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><!--smsContent--><div class="form-group"><label class="control-label" for="smsContent" translate="superChannelApp.setting.smsContent.label">smsContent</label> <input type="text" class="form-control" id="smsContent" name="smsContent" ng-model="vm.smsContent.settingValue" placeholder="{{\'superChannelApp.setting.smsContent.placeholder\' | translate }}" ng-minlength="1" ng-maxlength="100" required maxlength="100"><div ng-show="form.smsContent.$dirty && form.smsContent.$invalid"><p class="help-block" ng-show="form.smsContent.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.smsContent.$error.minlength" translate="entity.validation.minlength">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="form.smsContent.$error.maxlength" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p></div></div><!--smsFrom--><div class="form-group"><label class="control-label" for="smsFrom" translate="superChannelApp.setting.smsFrom.label">smsFrom</label> <input type="text" class="form-control" id="smsFrom" name="smsFrom" placeholder="{{\'superChannelApp.setting.smsFrom.placeholder\' | translate }}" ng-model="vm.smsFrom.settingValue" ng-minlength="1" ng-maxlength="10" required maxlength="10" readonly="readonly" uib-tooltip="{{\'settings.messages.validate.smsfrom\'|translate}}"><div ng-show="form.smsFrom.$dirty && form.smsFrom.$invalid"><p class="help-block" ng-show="form.smsFrom.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.smsFrom.$error.minlength" translate="entity.validation.minlength">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="form.smsFrom.$error.maxlength" translate="entity.validation.maxlength">This field cannot be longer than 10 characters.</p></div></div><!--tenantLanguage--><div class="form-group"><label for="langKey" translate="superChannelApp.setting.tenantLanguage.label">Language</label> <select id="langKey" name="langKey" class="form-control" ng-model="vm.tenantLanguage.settingValue" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><!--expiration time--><div class="form-group"><label class="control-label" for="expirationTime" translate="superChannelApp.setting.expirationTime.label">expiration time</label> <input type="number" min="1" max="240" class="form-control" id="expirationTime" name="expirationTime" required ng-model="vm.expirationTime.settingValue" placeholder="{{\'superChannelApp.setting.expirationTime.placeholder\' | translate }}"><div ng-show="form.expirationTime.$dirty && form.expirationTime.$invalid"><p class="help-block" ng-show="form.expirationTime.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.expirationTime.$error.min" translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="help-block" ng-show="form.expirationTime.$error.max" translate="entity.validation.max" translate-value-max="240">This field cannot be more than 240.</p></div></div><!--smsContent--><div class="form-group"><label class="control-label" for="mailDomain" translate="superChannelApp.setting.mailDomain.label">mailDomain</label> <input type="text" class="form-control" id="mailDomain" name="mailDomain" ng-model="vm.mailDomain.settingValue" placeholder="{{\'superChannelApp.setting.mailDomain.placeholder\' | translate }}" ng-minlength="1" required><div ng-show="form.mailDomain.$dirty && form.mailDomain.$invalid"><p class="help-block" ng-show="form.mailDomain.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.mailDomain.$error.minlength" translate="entity.validation.minlength">This field is required to be at least 1 characters.</p></div></div><!--smsContent--><div class="form-group"><label class="control-label" for="sessionDomain" translate="superChannelApp.setting.sessionDomain.label">sessionDomain</label> <input type="text" class="form-control" id="sessionDomain" name="sessionDomain" ng-model="vm.sessionDomain.settingValue" placeholder="{{\'superChannelApp.setting.sessionDomain.placeholder\' | translate }}" ng-minlength="1" required><div ng-show="form.sessionDomain.$dirty && form.sessionDomain.$invalid"><p class="help-block" ng-show="form.sessionDomain.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.sessionDomain.$error.minlength" translate="entity.validation.minlength">This field is required to be at least 1 characters.</p></div></div><div class="form-group"><label class="control-label" for="callbackUrl" translate="superChannelApp.setting.callbackUrl.label">callbackUrl</label> <input type="text" class="form-control" id="callbackUrl" name="callbackUrl" ng-model="vm.callbackUrl.settingValue" placeholder="{{\'superChannelApp.setting.callbackUrl.placeholder\' | translate }}" starts-with="https"><div ng-show="form.callbackUrl.$dirty && form.callbackUrl.$invalid"><p class="help-block" ng-show="form.callbackUrl.$error.startswith" translate="entity.validation.https">This field must use HTTPS.</p></div></div><div class="form-group"><label for="captchaKey">Enable Captcha</label> <select id="captchaKey" name="captchaKey" class="form-control" ng-model="vm.captchaEnabled.settingValue" ng-options="o as o for o in vm.captchaEnabledOptions"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label translate="global.field.id">ID</label> <input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="userManagement.login">Login</label> <input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" translate="userManagement.firstName">First Name</label> <input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label translate="userManagement.lastName">Last Name</label> <input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" translate="userManagement.email">Email</label> <input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label translate="userManagement.langKey">Lang Key</label> <select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as (language | findLanguageFromKey) for language in vm.languages track by language"></select></div><div class="form-group"><label translate="userManagement.profiles">Profiles</label> <select class="form-control" multiple="multiple" required name="authority" ng-model="vm.user.authorities" ng-options=" \'userManagement.role.\' + authority | translate for authority in vm.authorities"></select><div ng-show="editForm.authority.$invalid"><p class="help-block" ng-show="editForm.authority.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="userManagement.channels">Channels</label> <select class="form-control" multiple="multiple" name="channel" ng-model="vm.user.allowedChannels" ng-options="channel.name for channel in vm.channels track by channel.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management-new"><span class="glyphicon glyphicon-flash"></span> <span translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="login"><span translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="langKey"><span translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="userManagement.profiles">Profiles</span></th><th><span translate="userManagement.channels">Channels</span></th><th jh-sort-by="createdDate"><span translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><pre>{{user.login}}</pre></td><td><pre>{{user.email}}</pre></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ \'userManagement.role.\' + authority | translate }}</span></div></td><td><div ng-repeat="channel in user.allowedChannels"><span class="label label-info">{{ channel.name }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management-delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/canvasViewer/canvas-viewer.html','<div class="container-fluid" style=""><div class="canvas-viewer"><canvas-viewer src="vm.fileInput" options="vm.options"></canvas-viewer></div></div>');
$templateCache.put('app/components/expiredPassword/expired-password.html','<!--<div class="modal-dialog modal-dialog-center">--><form class="modal-content" name="form" role="form" novalidate ng-submit="vm.changeExpiredPassword()" show-validation><div class="modal-body"><div class="panel-body"><div class="alert alert-success" ng-show="vm.success" translate="password.messages.success"><strong>Password changed!</strong></div><div id="passwordExpiredAlert" class="alert alert-danger" translate="password.messages.expired"><strong>Password expired!</strong> The password should be changed.</div><div class="alert alert-danger" ng-show="vm.error"><button type="button" class="close" ng-click="vm.close()" aria-hidden="true">\xD7</button><div translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div></div><div class="alert alert-danger" ng-show="vm.doNotMatch"><button type="button" class="close" ng-click="vm.close()" aria-hidden="true">\xD7</button><div translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="alert alert-danger" ng-show="vm.samePassword"><button type="button" class="close" ng-click="vm.close()" aria-hidden="true">\xD7</button><div translate="global.messages.error.samePassword"><strong>New password</strong> cannot be the same as the <strong>old password!</strong></div></div><div><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label> <input pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" id="password" name="password" type="password" ng-model="vm.password" class="form-control" placeholder="{{\'global.form.newpassword.placeholder\' | translate }}" title="{{ \'password.messages.pattern\' | translate }}" ng-minlength="8" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 8 characters.</p><p class="help-block" ng-show="form.password.$error.pattern" translate="global.messages.validate.newpassword.pattern">Your password is required to have uppercase, lowercase and numbers.</p></div></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label> <input pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" id="confirmPassword" name="confirmPassword" type="password" ng-model="vm.confirmPassword" class="form-control" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" title="{{ \'password.messages.pattern\' | translate }}" ng-minlength="8" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 8 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.pattern" translate="global.messages.validate.confirmpassword.pattern">Your confirmation password is required to have uppercase, lowercase and numbers.</p></div></div></div><div class="form-group"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary pull-right" translate="password.form.button">Save</button> <button type="button" class="btn btn-primary pull-left" data-dismiss="modal" ng-click="vm.clear()" translate="entity.action.cancel">Cancel</button></div></div></div></form><!--</div>-->');
$templateCache.put('app/entities/item/item-document-dialog.html','<div role="dialog"><div class="modal-dialog modal-dialog-center"><div class="modal-content col-sm-11 col-sm-offset-1"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myItemLabel" translate="superChannelApp.item.document.label.title">Send document</h4></div><div class="modal-body"><div class="panel-body" ng-if="vm.showButtons && vm.documentLibraryTitles.length > 0"><div class="form-group col-sm-12"><button class="btn btn-primary btn-block" id="content-library" ng-click="vm.contentLibrary()" translate="entity.action.library">Library</button></div><div class="form-group col-sm-12"><button class="btn btn-primary btn-block" id="local-upload" ng-click="vm.localUpload()" translate="entity.action.local">Upload Local</button></div></div><div class="panel-body" ng-if="vm.isLocal || vm.documentLibraryTitles.length == 0"><strong><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></strong><div class="form-group col-sm-12"><input type="file" name="document" id="file_document" class="form-control" placeholder="{{ \'superChannelApp.item.document.msg.input\' | translate}}" ng-model="vm.item.content.binaryData" app-filereader required><div ng-show="editForm.document.$invalid"><p class="help-block" ng-show="editForm.document.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-sm-12"><button ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-block" id="save" translate="entity.action.send">Send</button></div></div><div class="panel-body" ng-show="vm.isContentLibrary && vm.documentLibraryTitles.length > 0"><strong><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></strong><div class="form-group col-sm-12"><select class="form-control col-sm-12" ng-model="vm.item.content" ng-options="item.title for item in vm.documentLibraryTitles"></select><div ng-show="editForm.document.$invalid"><p class="help-block" ng-show="editForm.document.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-sm-12"><button ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-block" id="content-send" translate="entity.action.send">Send</button></div></div></div></form></div></div></div>');
$templateCache.put('app/entities/item/item-location-dialog.html','<div role="dialog"><div class="modal-dialog modal-dialog-center"><div class="modal-content col-sm-7 col-sm-offset-2"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myItemLabel" translate="superChannelApp.item.location.label.title">Send location</h4></div><div class="modal-body"><div class="panel-body"><strong><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></strong><div class="form-group col-sm-12" ng-class="{ \'has-error\': editForm.latitude.$invalid && editForm.latitude.$dirty }"><input type="number" min="-90" max="90" class="form-control" name="latitude" id="field_latitude" ng-model="vm.item.content.latitude" placeholder="{{ \'superChannelApp.item.location.label.latitude\' | translate}}" required><div ng-show="editForm.latitude.$invalid"><p class="help-block" id="latitude-required-help" ng-show="editForm.latitude.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" id="latitude-invalid-help" ng-show="!editForm.latitude.$error.required && editForm.latitude.$invalid" translate="superChannelApp.item.location.help.latitude">Latitude must be a number between -90 and 90</p></div></div><div class="form-group col-sm-12" ng-class="{ \'has-error\': editForm.longitude.$invalid && editForm.longitude.$dirty }"><input type="number" min="-180" max="180" class="form-control" name="longitude" id="field_longitude" ng-model="vm.item.content.longitude" placeholder="{{ \'superChannelApp.item.location.label.longitude\' | translate}}" required><div ng-show="editForm.longitude.$invalid"><p class="help-block" id="longitude-required-help" ng-show="editForm.longitude.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" id="longitude-invalid-help" ng-show="!editForm.longitude.$error.required && editForm.longitude.$invalid" translate="superChannelApp.item.location.help.longitude">Latitude must be a number between -90 and 90</p></div></div><div class="form-group col-sm-12"><button ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-block" id="save" translate="entity.action.send">Send</button></div></div></div></form></div></div></div>');
$templateCache.put('app/entities/item/item-photo-dialog.html','<div role="dialog"><div class="modal-dialog modal-dialog-center"><div class="modal-content col-sm-10 col-sm-offset-1"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myItemLabel" translate="superChannelApp.item.photo.label.title">Send image</h4></div><div class="modal-body"><div class="panel-body" ng-if="vm.showButtons && vm.photoLibraryTitles.length > 0"><div class="form-group col-sm-12"><button class="btn btn-primary btn-block" id="content-library" ng-click="vm.contentLibrary()" translate="entity.action.library">Library</button></div><div class="form-group col-sm-12"><button class="btn btn-primary btn-block" id="local-upload" ng-click="vm.localUpload()" translate="entity.action.local">Upload Local</button></div></div><div class="panel-body" ng-if="vm.isLocal || vm.photoLibraryTitles.length == 0"><strong><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></strong><div class="form-group col-sm-12"><input type="file" accept="{{vm.photoExtensions}}" name="photo" id="file_document" class="form-control" placeholder="{{ \'superChannelApp.item.photo.msg.input\' | translate}}" ng-model="vm.item.content.binaryData" app-filereader required><div ng-show="editForm.photo.$invalid"><p class="help-block" ng-show="editForm.photo.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-sm-12"><button ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-block" id="local-send" translate="entity.action.send">Send</button></div></div><div class="panel-body" ng-show="vm.isContentLibrary && vm.photoLibraryTitles.length > 0"><strong><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></strong><div class="form-group col-sm-12"><select class="form-control col-sm-12" ng-model="vm.item.content" ng-options="item.title for item in vm.photoLibraryTitles"></select><div ng-show="editForm.photo.$invalid"><p class="help-block" ng-show="editForm.photo.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-sm-12"><button ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-block" id="content-send" translate="entity.action.send">Send</button></div></div></div></form></div></div></div>');
$templateCache.put('app/entities/item/item-sketch-dialog.html','<div role="dialog"><script>var canvas = document.querySelector("canvas");\n        var signaturePad = new SignaturePad(canvas, {\n            backgroundColor: \'rgb(255, 255, 255)\'\n        });</script><div class="modal-dialog modal-dialog-center"><div class="modal-content col-sm-10 col-sm-offset-1"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation id="sketch_form"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myItemLabel" translate="superChannelApp.item.sketch.label.title">Send sketch</h4></div><div class="modal-body"><div class="panel-body"><div style="width:380px; height:380px" class="canvas-container"><canvas width="380px" height="380px"></canvas><div class="canvas-controls"><div ng-click="vm.redPen()" style="color: red;"><span class="glyphicon glyphicon-pencil"></span></div><div ng-click="vm.blackPen()"><span class="glyphicon glyphicon-pencil"></span></div><div ng-click="vm.clearPad()"><span class="glyphicon glyphicon-trash"></span></div></div></div><div class="form-group col-sm-12"><button ng-disabled="editForm.$invalid || vm.isSaving || vm.isEmpty()" class="btn btn-primary btn-block" id="saveButton" translate="entity.action.send">Send</button></div></div></div></form></div></div></div>');
$templateCache.put('app/entities/item/item-url-dialog.html','<div role="dialog"><div class="modal-dialog modal-dialog-center"><div class="modal-content col-sm-10 col-sm-offset-1"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myItemLabel" translate="superChannelApp.item.url.label.title">Send url</h4></div><div class="modal-body"><div class="panel-body" ng-if="vm.showButtons && vm.urlLibrary.length > 0"><div class="form-group col-sm-12"><button class="btn btn-primary btn-block" id="content-library" ng-click="vm.contentLibrary()" translate="entity.action.library">Library</button></div><div class="form-group col-sm-12"><button class="btn btn-primary btn-block" id="local-upload" ng-click="vm.localUpload()" translate="entity.action.url">Enter URL</button></div></div><div class="panel-body" ng-if="vm.isLocal || vm.urlLibrary.length == 0"><strong><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error></strong><div class="form-group col-sm-12" ng-class="{ \'has-error\': editForm.url.$invalid && editForm.url.$dirty }"><input type="text" class="form-control" name="url" id="field_url" ng-model="vm.item.content.url" placeholder="{{ \'superChannelApp.item.url.msg.input\' | translate}}" required><div ng-show="editForm.url.$invalid"><p class="help-block" id="required-help" ng-show="editForm.url.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-sm-12"><button ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-block" id="save" translate="entity.action.send">Send</button></div></div><div class="panel-body" ng-show="vm.isContentLibrary && vm.urlLibrary.length > 0"><strong><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></strong><div class="form-group col-sm-12"><select class="form-control col-sm-12" ng-model="vm.item.content" ng-options="item.title for item in vm.urlLibrary"></select><div ng-show="editForm.photo.$invalid"><p class="help-block" ng-show="editForm.photo.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-sm-12"><button ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-block" id="content-send" translate="entity.action.send">Send</button></div></div></div></form></div></div></div>');
$templateCache.put('app/entities/item/item-video-dialog.html','<script src="//media.twiliocdn.com/sdk/js/video/releases/2.0.0-beta15/twilio-video.min.js"></script><div role="dialog"><div class="modal-dialog modal-dialog-center"><div class="modal-content col-sm-10 col-sm-offset-1"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myItemLabel" translate="superChannelApp.item.video.label.title">Live Video</h4></div><div class="modal-body"><div class="panel-body col-sm-12"><div id="local-media-div" class="img-responsive" style="display: flex; justify-content: center; align-items: center; padding: 15px"></div><div class="form-group col-sm-12" ng-show="!vm.liveVideoActive"><button class="btn btn-primary btn-block" ng-click="toggle = !toggle" translate="superChannelApp.item.video.label.open">Open Live Video</button></div><div class="form-group col-sm-12" ng-show="vm.liveVideoActive"><button class="btn btn-primary btn-block" ng-click="toggle = !toggle" translate="superChannelApp.item.video.label.close">Close Live Video</button></div></div></div></form></div></div></div>');
$templateCache.put('app/entities/session/session-detail.html','<div class="container-relative" id="sessionDetail"><strong><jhi-alert-error ng-hide="vm.dialogOpen" class="col-sm-4 col-sm-offset-8 navbar-fixed-top" aria-hidden="true" style="top: 10%; word-break: break-all; text-align: justify; overflow: hidden;"></jhi-alert-error><jhi-alert ng-hide="vm.dialogOpen" class="col-sm-4 col-sm-offset-8 navbar-fixed-top" aria-hidden="true" style="top: 10%; word-break: break-all; text-align: justify; overflow: hidden;"></jhi-alert></strong><timeline><timeline-event ng-repeat="element in vm.timelineList" side="{{element.side}}" class="{{element.source.position}}"><timeline-badge when-visible="animateElementIn" when-not-visible="animateElementOut" class="{{element.badgeClass}}"><i class="{{element.badgeIconClass}}"></i></timeline-badge><timeline-panel when-visible="animateElementIn" when-not-visible="animateElementOut" class="{{element.badgeClass}}"><timeline-heading><h4>{{element.title}}</h4></timeline-heading><p ng-if="element.photoContent"><a class="thumbnail" ui-sref="canvas({tenant: \'pht\', photo: element.photoUrl})" target="_blank"><img ng-src="{{element.photoUrl}}"></a></p><p ng-if="element.content" ng-bind-html="element.content"></p><p translate="{{element.msg}}" translate-values="{{element.translateValues}}"></p><p><small class="text-muted ng-binding"><i class="fa fa-clock-o"></i> {{element.timestamp | date : \'short\'}}</small></p></timeline-panel></timeline-event></timeline></div><aside class="main-sidebar" ng-show="vm.session.id"><section class="sidebar"><ul class="sidebar-menu sidebar-top"><li ng-repeat="button in vm.itemCreationButtons"><a ng-click="vm.createItem(button.channel)" ng-attr-id="{{button.channel.itemContenttype}}" class="btn text-center" ng-class="{\'disabled\': vm.isExpired}"><i class="sidebar-icons glyphicon" tooltip-placement="right" uib-tooltip="{{button.channel.name|translate}}" ng-class="{\'glyphicon-picture\': button.channel.itemContentType === \'PHOTO\',\n                           \'glyphicon-map-marker\': button.channel.itemContentType === \'LOCATION\',\n                           \'glyphicon-paperclip\': button.channel.itemContentType === \'DOCUMENT\',\n                           \'glyphicon-link\': button.channel.itemContentType === \'URL\',\n                           \'glyphicon-pencil\': button.channel.itemContentType === \'SKETCH\',\n                           \'glyphicon-facetime-video\': button.channel.itemContentType === \'VIDEO\'}"></i></a></li></ul><ul class="sidebar-menu sidebar-bottom"><li><a ng-click="vm.expireSession()" id="expire" class="btn text-center" ng-class="{\'disabled\': vm.isExpired}"><i ng-show="!vm.isExpired" tooltip-placement="right" tooltip-placement="right" uib-tooltip="{{\'superChannelApp.session.expiration.title\'|translate}}" class="sidebar-icons glyphicon glyphicon-ok"></i> <i ng-show="vm.isExpired" tooltip-placement="right" tooltip-placement="right" uib-tooltip="{{\'session.label.expired_session\'|translate}}" class="sidebar-icons glyphicon glyphicon-remove red-icon"></i></a></li><li class="countdown"><a ng-if="!vm.isExpired && vm.session.end" countdown endtime="vm.session.end" isexpired="vm.isExpired" class="text-center"></a></li></ul></section></aside>');
$templateCache.put('app/entities/session/session-dialog.html','<div role="dialog"><div class="modal-dialog modal-dialog-center"><div class="modal-content col-sm-10"><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.clear()" aria-hidden="true">\xD7</button><h4 class="modal-title" translate="superChannelApp.session.home.createLabel">Create new Session</h4></div><div class="modal-body"><div class="panel-body"><strong><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></strong><div><div class="to-left col-sm-4"><select ng-change="vm.onChange(this.body)" ng-model="vm.sessionType" class="form-control" id="sessionOption"><option value="sms" translate="superChannelApp.session.sessionType.SMS" ng-selected="vm.sessionType == \'sms\'">SMS</option><option value="web" translate="superChannelApp.session.sessionType.web" ng-selected="vm.sessionType != \'sms\'">Web</option></select></div><div ng-if="vm.sessionType == \'sms\'" class="to-left col-sm-8"><input type="text" class="form-control" name="target" id="target" ng-model="vm.session.target" placeholder="{{\'superChannelApp.session.clientphone\' | translate }}" required><div ng-show="form.target.$dirty && form.target.$invalid"><div ng-show="form.target.$dirty && form.target.$invalid"><p class="help-block" ng-show="form.target.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><br><br><br><div class="form-group col-sm-12" ng-show="vm.allowedChannels.length>0"><p translate="superChannelApp.session.clientAllowedChannels.label">Client Allowed Channels</p><div class="allowedChannels form-group" ng-repeat="channel in vm.allowedChannels"><input type="checkbox" id="{{channel.id}}" value="{{channel.id}}" ng-model="vm.selectedChannels[channel.id]" name="channel.name"> {{channel.name}}</div></div><div class="form-group col-sm-12"><button ng-disabled="form.$invalid || vm.isSaving" class="btn btn-primary btn-block" translate="entity.action.send" id="save">Send</button></div></div></div></div></form></div></div></div>');
$templateCache.put('app/entities/session/session-expiration-dialog.html','<form name="form" role="form" novalidate ng-submit="vm.expire()" show-validation><div class="modal-content col-sm-10 col-sm-offset-1"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.clear()" aria-hidden="true">\xD7</button><h4 class="modal-title" translate="superChannelApp.session.expiration.title">Expire session</h4></div><div class="modal-body"><div class="panel-body"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><p translate="superChannelApp.session.expiration.question">You are going to expire the session. Do you want to continue?</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="vm.isSaving" class="btn btn-danger pull-right" id="confirmExpiration"><span ng-class="vm.isSaving ? \'glyphicon glyphicon-refresh glyphicon-spin\' : \'glyphicon glyphicon-remove\'"></span>&nbsp;<span translate="superChannelApp.session.expiration.btn">Expire</span></button></div></div></form>');
$templateCache.put('app/entities/session/sessions.html','<div><!-- Search bar --><form name="editForm" role="form" novalidate ng-submit="vm.search()" show-validation><div class="row"><div class="form-group col-sm-1"><input type="text" class="form-control" name="sessionId" id="field_sessionId" placeholder="{{ \'global.field.id\' | translate}}" ng-model="vm.searchParams.sessionId"></div><div class="form-group col-sm-2"><input type="text" class="form-control" name="target" id="field_target" placeholder="{{ \'superChannelApp.session.target\' | translate}}" ng-model="vm.searchParams.target"></div><div class="form-group col-sm-2"><input type="text" class="form-control" name="agent" id="field_agent" placeholder="{{ \'superChannelApp.session.creator\' | translate}}" ng-model="vm.searchParams.agent"></div><div class="form-group col-sm-3"><div class="input-group"><input id="field_start" type="text" class="form-control" name="start" placeholder="{{ \'superChannelApp.session.start\' | translate}}" datetime-picker="{{dateformat}}" ng-model="vm.searchParams.start" button-bar="vm.datePickerButtonBar" is-open="vm.datePickerOpenStatus.start" ng-click="vm.openCalendar(\'start\')"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'start\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group col-sm-3"><div class="input-group"><input id="field_end" type="text" class="form-control" name="end" placeholder="{{ \'superChannelApp.session.end\' | translate}}" datetime-picker="{{dateformat}}" ng-model="vm.searchParams.end" button-bar="vm.datePickerButtonBar" is-open="vm.datePickerOpenStatus.end" ng-click="vm.openCalendar(\'end\')"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'end\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><button id="search" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-default pull-right"><i class="fa fa-search pull-left"></i><span translate="superChannelApp.session.search">Search</span></button></div></form><!-- !Search bar --><!--<jhi-alert></jhi-alert>--><br><div class="table-responsive"><table id="sessions" class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="target"><span translate="superChannelApp.session.target">Client Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="creator"><span translate="superChannelApp.session.creator">Agent</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="start"><span translate="superChannelApp.session.start">Start time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="end"><span translate="superChannelApp.session.end">End time</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions track by session.id"><td><a ui-sref="session-detail({id:session.id})">{{session.id}}</a></td><td>{{session.target}}</td><td>{{session.creator}}</td><td>{{session.start | date:\'medium\'}}</td><td>{{session.end | date:\'medium\'}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1 translate="error.title">Error Page!</h1><div class="alert alert-danger" translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default navbar-fixed-top sch-navbar" role="navigation"><div class="navbar-header main-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a href="#/{{vm.currentTenant}}" ng-click="vm.collapseNavbar()" class="navbar-brand"><!-- logo for regular state and mobile devices --> <img class="logo-img" src="/content/images/{{vm.currentTenant}}.png"></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li has-authority="ROLE_AGENT" class="pointer" tooltip-placement="bottom" uib-tooltip="{{\'global.menu.session.create\'|translate}}"><a ui-sref="sessionnew"><span class="glyphicon glyphicon-plus"></span>&nbsp;</a></li><li ui-sref-active="active" has-authority="ROLE_AGENT" class="pointer" tooltip-placement="bottom" uib-tooltip="{{\'global.menu.session.list\'|translate}}"><a ui-sref="session"><span class="glyphicon glyphicon-th-list"></span>&nbsp;</a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="setting" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cog"></span>&nbsp; <span translate="global.menu.entities.setting">Setting</span></a></li><li ui-sref-active="active"><a ui-sref="channel" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-send"></span>&nbsp; <span translate="global.menu.entities.channel">Channel</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'superadmin\')}" ng-switch-when="true" has-authority="ROLE_SUPERADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="superadmin-menu"><span><span class="glyphicon glyphicon-globe"></span> <span class="hidden-sm" translate="global.menu.superadmin.main">App Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span translate="global.menu.admin.logs">Logs</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'supervisor\')}" ng-switch-when="true" has-authority="ROLE_SUPERVISOR" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="supervisor-menu"><span><span class="glyphicon glyphicon-search"></span> <span class="hidden-sm" translate="global.menu.supervisor.name">Supervisor</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="statistics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-stats"></span>&nbsp; <span translate="global.menu.supervisor.statistics">Statistics</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" ng-show="vm.isAuthenticated()" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm">{{vm.login}} </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true" has-authority="ROLE_ADMIN"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true" has-authority="ROLE_ADMIN"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span translate="global.menu.account.login">Sign in</span></a></li></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></nav>');
$templateCache.put('app/superadmin/audits/audits.html','<div><h2 translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/superadmin/configuration/configuration.html','<div><h2 translate="configuration.title">Configuration</h2><span translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"> <label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span translate="configuration.table.prefix">Prefix</span></th><th translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/superadmin/health/health.html','<div><h2 translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" translate="health.table.service">Service Name</th><th class="col-md-2 text-center" translate="health.table.status">Status</th><th class="col-md-2 text-center" translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/superadmin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" translate="health.details.name">Name</th><th class="col-md-6 text-left" translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/superadmin/logs/logs.html','<div class="table-responsive"><h2 translate="logs.title">Logs</h2><p translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/superadmin/metrics/metrics.html','<div><h2 translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="metrics.refresh.button">Refresh</span></button></p><h3 translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b translate="metrics.jvm.memory.title">Memory</b><p><span translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" translate="metrics.updating">Updating...</div><h3 translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.jvm.http.table.code">Code</th><th translate="metrics.jvm.http.table.count">Count</th><th class="text-right" translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" translate="metrics.servicesstats.table.count">Count</th><th class="text-right" translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" translate="metrics.servicesstats.table.min">Min</th><th class="text-right" translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate="metrics.ehcache.title">Ehcache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.ehcache.cachename">Cache name</th><th class="text-right" translate="metrics.ehcache.objects">Objects</th><th class="text-right" translate="metrics.ehcache.hits">Hits</th><th class="text-right" translate="metrics.ehcache.misses">Misses</th><th class="text-right" translate="metrics.ehcache.evictioncount">Eviction count</th><th class="text-right" translate="metrics.ehcache.mean">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class="text-right" translate="metrics.datasource.count">Count</th><th class="text-right" translate="metrics.datasource.mean">Mean</th><th class="text-right" translate="metrics.datasource.min">Min</th><th class="text-right" translate="metrics.datasource.p50">p50</th><th class="text-right" translate="metrics.datasource.p75">p75</th><th class="text-right" translate="metrics.datasource.p95">p95</th><th class="text-right" translate="metrics.datasource.p99">p99</th><th class="text-right" translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/superadmin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/supervisor/statistics/statistics.html','<div><div id="chart_container" class="to-left"><div class="btn-group" id="granularityBtn"><button id="{{granularity}}" ng-repeat="granularity in vm.granularities" type="button" ng-class="(vm.granularity===granularity)? \'btn btn-info\': \'btn btn-default\'" ng-model="vm.granularity" ng-click="vm.changeGranularity(granularity)">{{"statistics.granularity." + granularity|translate}}</button></div><br><canvas id="chart" class="chart chart-bar" chart-legend="true"></canvas></div><div class="col-sm-3 to-right" id="chartForm"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.getChart()" show-validation><div><div class="form-group"><label for="interval" class="to-left control-label" translate="statistics.timeRange.label">Time Range</label><div id="interval" class="to-right col-sm-8"><select id="inter" ng-change="vm.changeInterval()" class="form-control" ng-model="vm.interval"><option value="{{interval}}" ng-repeat="interval in vm.intervals">{{\'statistics.timeRange.\' + interval|translate}}</option></select></div></div><div class="form-group"><label for="startPicker" class="to-left control-label" translate="statistics.startTime.label">Start Time</label><div class="datePicker input-group col-sm-8" id="startPicker"><input id="start" type="text" class="form-control" placeholder="{{\'statistics.startTime.label\'|translate}}" datetime-picker="dd MM yyyy" ng-model="vm.startPicker.date" enable-time="false" button-bar="vm.datePickerButtonBar" is-open="vm.datePickerOpenStatus.startPicker" enable-time="false" ng-click="vm.openCalendar(\'startPicker\')" datepicker-options="vm.startPicker.datepickerOptions" required ng-disabled="!(vm.interval===\'custom\')"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startPicker\')" ng-disabled="!(vm.interval===\'custom\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="endPicker" class="to-left control-label" translate="statistics.endTime.label">End Time</label><div class="datePicker input-group col-sm-8" id="endPicker"><input id="end" type="text" class="form-control" placeholder="{{\'statistics.endTime.label\'|translate}}" datetime-picker="dd MM yyyy" ng-model="vm.endPicker.date" enable-time="false" button-bar="datePickerButtonBar" is-open="vm.datePickerOpenStatus.endPicker" enable-time="false" ng-click="vm.openCalendar(\'endPicker\')" datepicker-options="vm.endPicker.datepickerOptions" required ng-disabled="!(vm.interval===\'custom\')"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endPicker\')" ng-disabled="!(vm.interval===\'custom\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="filterBy" class="to-left control-label" translate="statistics.filterBy.label">Filter by</label><div id="filterBy" class="to-right col-sm-8"><ui-select id="filter" ng-model="vm.multiple.selected" multiple="multiple"><ui-select-match placeholder="{{\'statistics.filterBy.placeholder\'|translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="agent in vm.agents | filter: $select.search"><div ng-bind-html="trustAsHtml((agent.name | highlight: $select.search))"></div></ui-select-choices></ui-select></div></div><div class="form-group"><label for="groupBy" class="to-left control-label" translate="statistics.groupBy.label">Group by</label><div id="groupBy" class="to-right col-sm-8"><select ng-model="vm.groupBy" class="form-control"><option value="" translate="statistics.groupBy.none">None</option><option value="AGENT" translate="statistics.groupBy.agent">Agent</option></select></div></div><button id="send" type="submit" class="btn btn-success pull-right" ng-disabled="editForm.$invalid" translate="statistics.generate.chart">Generate chart</button></div></form></div></div><div id="results" class="col-md-12 table-responsive"><table id="resultsTable" class="table table-striped table-scroll"><thead class="results-head"><tr><th ng-show="vm.params.groupBy === \'AGENT\'"></th><th class="results-head" ng-show="vm.params.groupBy !== \'AGENT\'"></th><th class="results-head" ng-repeat="label in vm.labels track by $index">{{label}}</th><th class="results-head" translate="statistics.table.total">Total</th></tr></thead><tbody><tr><th class="results-head" translate="statistics.table.numberSessions">Number of sessions</th><td class="align-text" ng-repeat="value in vm.totalPerColumn track by $index">{{value}}</td><td class="align-text">{{vm.total}}</td></tr><tr ng-show="(vm.params.groupBy === \'AGENT\')" ng-repeat="item in vm.series track by $index"><th class="results-head">{{item.label}}</th><td class="align-text" ng-repeat="value in item.data track by $index">{{value}}</td><td class="align-text">{{vm.totalPerRow[$index]}}</td></tr></tbody></table></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label> <input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="8" ng-maxlength="50" pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 8 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.password.$error.pattern" translate="global.messages.validate.newpassword.pattern">Your password is required to have uppercase, lowercase and numbers.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="8" ng-maxlength="50" pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.pattern" translate="global.messages.validate.confirmpassword.pattern">Your password is required to have uppercase, lowercase and numbers.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<script src="https://www.google.com/recaptcha/api.js" async defer="defer"></script><div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" ng-show="vm.captchaError"><button type="button" class="close" ng-click="vm.clear()" aria-hidden="true">\xD7</button><div translate="reset.request.messages.captcha"><strong>Captcha could not be validated!</strong></div></div><div class="alert alert-warning" ng-hide="vm.success"><div><p translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><div><p translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div></div><div class="alert alert-danger" translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><button type="button" class="close" ng-click="vm.clear()" aria-hidden="true">\xD7</button><div><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label> <input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><div ng-show="vm.isCaptchaEnabled" class="g-recaptcha" data-theme="light" data-sitekey="{{vm.dataSiteKey}}"></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();